// src/App.js
import {Popover, Avatar} from 'antd';
import React, { useState, useEffect, useRef, useMemo, createContext, useContext } from 'react';
import { Layout, Typography,Switch,Alert, Divider,Menu,Tag, List,Select, Card,Drawer,Modal, Button, Input, message, Form, Row, Col, Dropdown, Tooltip, Space,Collapse, Spin } from 'antd';
import ApiForm from './components/ApiForm';
import Joyride, { STATUS } from 'react-joyride';
import RecipeList from './components/RecipeList';
import RecipeForm from './components/RecipeForm';
import RecipeRunner from './components/RecipeRunner';
import ExampleDrawerContent from './components/ExampleDrawerContent';
import ApiList from './components/ApiList';
import HistoryModal from './components/HistoryModal';
import ApiResponse from './components/ApiResponse';
import RequestCodeDisplay from './components/RequestCodeDisplay';
import OrgSwitcher from './components/OrgSwitcher';
import { apiService } from './services/apiService';
import ApiKeySelectorModal from './components/ApiKeySelectorModal';
// import AskAIModal from './components/AskAIModal';
import ApiManager from './components/ApiManager';
import {CheckOutlined } from '@ant-design/icons';
import apiClient from './services/axiosConfig';
import authAxios from './services/authService';
import { invokeEdgeFunction } from './services/edgeFunctionService';
import { LinkOutlined } from '@ant-design/icons';
import UserDropdown from './components/UserDropdown';
import IntegrationsModal from './components/IntegrationsModal';
import EdgeFunctionSandbox from './components/EdgeFunctionSandbox';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SlackCallback from './components/SlackCallback';
import {
  ExpandOutlined,
  ExperimentOutlined,
  CompressOutlined,
  CopyOutlined,
  ArrowRightOutlined,
  MenuOutlined,
  ToolOutlined,
  InfoCircleOutlined,
  ReadOutlined,
  AppstoreOutlined,
  HistoryOutlined,
  LoginOutlined,
  UserOutlined,
  SwapOutlined,
  DownOutlined,
 SearchOutlined,
  TeamOutlined,
  MessageOutlined,
  DeleteOutlined,
  ApiOutlined,
  QuestionCircleOutlined,
  FacebookOutlined,
  InstagramOutlined,
  LinkedinOutlined,
  BookOutlined,
  EyeOutlined,
  RocketOutlined,
  EyeInvisibleOutlined,
  PlusOutlined,
  TagsOutlined,
  CloseOutlined,
  CommentOutlined,
  DownloadOutlined,
  LogoutOutlined,
  DashboardOutlined,
  CodeOutlined,
  ThunderboltOutlined,
  SunOutlined,
  MoonOutlined
} from '@ant-design/icons';

// Import Google OAuth
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';

// Import UUID if needed
// import { v4 as uuidv4 } from 'uuid';
import ApiConfigForm from './components/ApiConfigForm';
import axios from 'axios';
import { ConfigProvider, theme as antdTheme } from 'antd';
import './App.css';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { okaidia } from 'react-syntax-highlighter/dist/esm/styles/prism';
import hljs from 'highlight.js';
import 'highlight.js/styles/atom-one-dark.css';

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const { Header, Content, Footer, Sider } = Layout;
const { Title, Paragraph } = Typography;
const { Option } = Select;
const { Text, Link } = Typography;
const { OptGroup } = Select; 

// Theme definitions
const themes = {
  dark: {
    name: 'dark',
    background: '#0a0a0a',
    surface: '#141414',
    surfaceLight: '#1a1a1a',
    border: '#2a2a2a',
    borderLight: '#333333',
    text: '#ffffff',
    textSecondary: '#a0a0a0',
    primary: '#2A85FF',
    primaryDark: '#1C63CC',
    accent: '#F9C626',
    accentDark: '#d4a922',
    success: '#00D59C',
    error: '#FF3838',
    codeBg: '#0d0d0d'
  },
  light: {
    name: 'light',
    background: '#ffffff',
    surface: '#f8fafc',      // Slightly lighter
    surfaceLight: '#ffffff',
    border: '#e2e8f0',        // Lighter border
    borderLight: '#cbd5e1',   // Lighter border
    text: '#0f172a',          // Darker text for better contrast
    textSecondary: '#64748b', // Lighter secondary text
    primary: '#3b82f6',       // Lighter blue
    primaryDark: '#2563eb',   // Lighter blue dark
    accent: '#f59e0b',        // Adjusted amber
    accentDark: '#d97706',
    success: '#10b981',       // Softer green
    error: '#ef4444',         // Softer red
    codeBg: '#f1f5f9'         // Light grayish blue for code
  }
};

// Create Theme Context
const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    return { theme: themes.dark, currentTheme: 'dark', switchTheme: () => {} };
  }
  return context;
};

function RouteCopyButton({ route }) {
  const [copied, setCopied] = useState(false);
  const { theme } = useTheme();

  const handleCopyRoute = () => {
    navigator.clipboard.writeText(route).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <Button
      type="text"
      icon={copied ? <CheckOutlined /> : <CopyOutlined />}
      onClick={handleCopyRoute}
      style={{ padding: '0 4px', color: theme.primary }}
    >
      {copied ? 'Copied!' : 'Copy'}
    </Button>
  );
}

// Move categoryMappings outside the component and make it a function that takes the theme
const getCategoryMappings = (theme) => [
  { name: "App", color: theme.primary, groupName: "App" },
  { name: "Auth", color: theme.accent, groupName: "Auth" },
  { name: "Account", color: theme.success, groupName: "Account" },
  { name: "Player/Me", color: "#FF6B6B", groupName: "Player" },
  { name: "Player/Others", color: "#C678DD", groupName: "Player" },
  { name: "Wallet", color: theme.primary, groupName: "Wallet" },
  { name: "Progression", color: theme.accent, groupName: "Progression" },
  { name: "Inventory", color: theme.success, groupName: "Inventory" },
  { name: "Stores", color: "#FF6B6B", groupName: "Stores" },
  { name: "Matches", color: "#C678DD", groupName: "Matches" },
  { name: "Leaderboards", color: theme.primary, groupName: "Leaderboards" },
  { name: "Competitions", color: theme.accent, groupName: "Competitions" },
  { name: "Achievements", color: theme.success, groupName: "Achievements" },
  { name: "Events", color: "#FF6B6B", groupName: "Events" },
  { name: "Live Ops", color: "#C678DD", groupName: "Live Ops" },
  { name: "Real Money Gaming", color: theme.primary, groupName: "Real Money Gaming" }
];

function App() {
  // Add global loading state
  const [isAppLoading, setIsAppLoading] = useState(true);
  
  // Theme state
  const [currentTheme, setCurrentTheme] = useState(() => {
    return localStorage.getItem('theme') || 'dark';
  });

  const switchTheme = (themeName) => {
    setCurrentTheme(themeName);
    localStorage.setItem('theme', themeName);
    document.documentElement.setAttribute('data-theme', themeName);
  };

  const theme = themes[currentTheme] || themes.dark; // Always provide a fallback theme
  
  // Store category mappings in state to ensure they update with theme changes
  // Use a function that provides fallback values if theme is undefined
  const [categoryMappings, setCategoryMappings] = useState(() => {
    const safeTheme = theme || themes.dark; // Fallback to dark theme if undefined
    return getCategoryMappings(safeTheme);
  });
  
  // Update category mappings when theme changes
  useEffect(() => {
    if (theme) {
      setCategoryMappings(getCategoryMappings(theme));
    }
  }, [theme]);

  // All your existing state variables remain the same
  const [apiKey, setApiKey] = useState(localStorage.getItem('apiKey') || '');
  const [bearerToken, setBearerToken] = useState(localStorage.getItem('bearerToken') || '');
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedApi, setSelectedApi] = useState(null);
  const [response, setResponse] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState('Node');
  const [selectedEnv, setSelectedEnv] = useState('console');
  const [codeSnippet, setCodeSnippet] = useState('');
  const [requestParams, setRequestParams] = useState({});
  const [editorExpanded, setEditorExpanded] = useState(false);
  const [isDevMode, setIsDevMode] = useState(false);
  const [showCredentials, setShowCredentials] = useState(true);
  const [apiGroups, setApiGroups] = useState([]);
  const [devIp, setDevIp] = useState(localStorage.getItem('devIp') || '');
  const [showDevServerCredentials, setShowDevServerCredentials] = useState(true);
  const prevIsDevModeRef = useRef(isDevMode);
  const [isAddingApi, setIsAddingApi] = useState(false);
  const [isEditingApi, setIsEditingApi] = useState(false);
  const [editingApiData, setEditingApiData] = useState(null);
  const [searchBoxValue, setSearchBoxValue] = useState('');
  const [integrationsModalVisible, setIntegrationsModalVisible] = useState(false);
  const [showApiKeySelector, setShowApiKeySelector] = useState(false);
  const [docsDrawerVisible, setDocsDrawerVisible] = useState(false);
  const [examplesDrawerVisible, setExamplesDrawerVisible] = useState(false);
  const [isRecipeMode, setIsRecipeMode] = useState(false);
  const [announcementVisible, setAnnouncementVisible] = useState(true);
  
  const [isAddingRecipe, setIsAddingRecipe] = useState(false);
  const [isEditingRecipe, setIsEditingRecipe] = useState(false);
  const [editingRecipeData, setEditingRecipeData] = useState(null);

  const [isRunningRecipe, setIsRunningRecipe] = useState(false);
  const [runningRecipeData, setRunningRecipeData] = useState(null);
  
  const [helpVisible, setHelpVisible] = useState(false);
  const [documentationTopics, setDocumentationTopics] = useState([]);
  const [docSearchQuery, setDocSearchQuery] = useState("");
  const [filteredDocs, setFilteredDocs] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [helpContent, setHelpContent] = useState({ title: '', content: '' });
  const [helpDrawerFullscreen, setHelpDrawerFullscreen] = useState(false);
 
  // const [askAIModalVisible, setAskAIModalVisible] = useState(false);
  
  const [leftSidebarCollapsed, setLeftSidebarCollapsed] = useState(false);
  const [activeSection, setActiveSection] = useState('sandbox');

  const [fieldGuideVisible, setFieldGuideVisible] = useState(false);
  const [groupOptions, setGroupOptions] = useState([]);

  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [saveStatus, setSaveStatus] = useState('saved');
  const [examplesDrawerFullscreen, setExamplesDrawerFullscreen] = useState(false);

  const [apiRefDrawerFullscreen, setApiRefDrawerFullscreen] = useState(false);
  const [askaiButtonBottom, setAskaiButtonBottom] = useState(24);
  const footerRef = useRef(null);

  const [loginStep, setLoginStep] = useState(0);

  const [orgs, setOrgs] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState(null);

  const [orgApiKeys, setOrgApiKeys] = useState({});

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const isProductionMode = process.env.REACT_APP_ENV === 'production';
  const [isRequestExpanded, setIsRequestExpanded] = useState(false);
  const SPECTER_ENV_URL = process.env.REACT_APP_SPECTER_ENV_URL;
  const [historyModalVisible, setHistoryModalVisible] = useState(false);


  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [loadingSubscription, setLoadingSubscription] = useState(false);
  const [showIntegrations, setShowIntegrations] = useState(false);

  // Edge Functions state
  const [edgeFunctions, setEdgeFunctions] = useState([]);
  const [selectedEdgeFunction, setSelectedEdgeFunction] = useState(null);
  const [edgeFunctionJwt, setEdgeFunctionJwt] = useState('');
  const [edgeFunctionResponse, setEdgeFunctionResponse] = useState(null);
  const [edgeFunctionLoading, setEdgeFunctionLoading] = useState(false);
  const [edgeFunctionsLoading, setEdgeFunctionsLoading] = useState(false);
  const [edgeFunctionProjects, setEdgeFunctionProjects] = useState([]);
  const [selectedEdgeFunctionProject, setSelectedEdgeFunctionProject] = useState(null);
  const [edgeFunctionEnv, setEdgeFunctionEnv] = useState(null);
  const [edgeFunctionProjectsLoading, setEdgeFunctionProjectsLoading] = useState(false);

  // Styles for Discord-like sidebar using theme
  const sidebarStyles = {
    background: theme.surface,
    padding: 0,
    position: 'fixed',
    height: '100vh',
    left: 0,
    top: 0,
    zIndex: 100,
    boxShadow: currentTheme === 'dark' ? '2px 0 12px rgba(0,0,0,0.5)' : '2px 0 12px rgba(0,0,0,0.1)',
    borderRight: `1px solid ${theme.border}`,
  };

  const sidebarItemStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    margin: '8px auto',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    backgroundColor: theme.surfaceLight,
    color: theme.textSecondary,
    border: `1px solid ${theme.border}`,
  };

  const activeSidebarItemStyles = {
    ...sidebarItemStyles,
    borderRadius: '16px',
    backgroundColor: theme.primary,
    color: '#ffffff',
    boxShadow: `0 0 12px ${theme.primary}40`,
    border: `1px solid ${theme.primary}`,
  };

  // Custom theme for Ant Design
  const customTheme = {
    token: {
      fontFamily: 'Inter, sans-serif',
      colorPrimary: theme.primary,
      colorPrimaryHover: theme.primaryDark,
      colorBgContainer: theme.surface,
      colorBgElevated: theme.surfaceLight,
      colorBorder: theme.border,
      colorText: theme.text,
      colorTextSecondary: theme.textSecondary,
      colorBgLayout: theme.background,
      borderRadius: 8,
      colorSuccess: theme.success,
      colorError: theme.error,
      // Add these for better dropdown styling in both light and dark modes
      colorFillSecondary: currentTheme === 'light' ? '#f1f5f9' : '#1f1f1f',
      colorFillTertiary: currentTheme === 'light' ? '#e2e8f0' : '#2a2a2a',
      colorFillQuaternary: currentTheme === 'light' ? '#f8fafc' : '#333333',
    },
    algorithm: currentTheme === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
    components: {
      Layout: {
        bodyBg: theme.background,
        headerBg: theme.surface,
        siderBg: theme.surface,
      },
      Card: {
        colorBgContainer: theme.surface,
        colorBorder: theme.border,
      },
      Input: {
        colorBgContainer: theme.surfaceLight,
        colorBorder: theme.border,
        colorText: theme.text,
        colorTextPlaceholder: currentTheme === 'dark' ? '#666666' : '#a0a0a0',
        activeBorderColor: theme.primary,
        hoverBorderColor: theme.primary,
      },
      Select: {
        colorBgContainer: theme.surfaceLight,
        colorBorder: theme.border,
        optionSelectedBg: currentTheme === 'light' ? '#e0f2fe' : theme.primaryDark,
        colorTextPlaceholder: currentTheme === 'dark' ? '#666666' : '#94a3b8',
        optionActiveBg: currentTheme === 'light' ? '#f0f9ff' : '#2a2a2a',
      },
      Button: {
        colorBgContainer: 'transparent',
        colorBorder: theme.border,
        primaryColor: '#ffffff',
        defaultBorderColor: theme.border,
        defaultColor: theme.text,
        algorithm: true,
      },
      Modal: {
        colorBgElevated: theme.surface,
        contentBg: theme.surface,
      },
      Drawer: {
        colorBgElevated: theme.surface,
      },
      Table: {
        colorBgContainer: theme.surface,
        colorBorderSecondary: theme.border,
      },
      Tag: {
        colorBgContainer: theme.surfaceLight,
        colorBorder: theme.border,
      },
      Tooltip: {
        colorBgSpotlight: theme.surfaceLight,
        colorTextLightSolid: theme.text,
      },
      Select: {
        colorBgContainer: theme.surfaceLight,
        colorBorder: theme.border,
        optionSelectedBg: currentTheme === 'light' ? '#e0f2fe' : theme.primaryDark,
        colorTextPlaceholder: currentTheme === 'dark' ? '#666666' : '#94a3b8',
        optionActiveBg: currentTheme === 'light' ? '#f0f9ff' : '#2a2a2a',
        dropdownBg: theme.surfaceLight,
      },
      Dropdown: {
        colorBgElevated: theme.surfaceLight,
        colorText: theme.text,
        colorTextDescription: theme.textSecondary,
      },
    },
  };
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', currentTheme);
  }, [currentTheme]);

  // Global app loading effect
  useEffect(() => {
    const loadApp = async () => {
      // Simulate loading time for a smooth experience
      await new Promise(resolve => setTimeout(resolve, 2000));
      setIsAppLoading(false);
    };
    
    loadApp();
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      setIsLoggedIn(localStorage.getItem('isLoggedIn') === 'true');
      setMemberName(localStorage.getItem('memberName') || '');
      setAuthToken(localStorage.getItem('authToken') || '');
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  // A palette of gaming-inspired colors
  const tagColors = [
    theme.primary,
    theme.accent,
    theme.success,
    '#FF6B6B',
    '#C678DD',
    '#61DAFB',
    '#FF8C00',
  ];

  useEffect(() => {
    const storedApiKey = localStorage.getItem('apiKey') || '';
    const storedBearerToken = localStorage.getItem('bearerToken') || '';
    
    if (apiKey !== storedApiKey || bearerToken !== storedBearerToken) {
      setHasUnsavedChanges(true);
      setSaveStatus('unsaved');
    } else {
      setHasUnsavedChanges(false);
      setSaveStatus('saved');
    }
  }, [apiKey, bearerToken]);

  const getTagColor = (index) => {
    return tagColors[index % tagColors.length];
  };
  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('memberName');
    localStorage.removeItem('memberId'); // Add this line
    localStorage.removeItem('authToken');
    localStorage.removeItem('apiKey');
    localStorage.removeItem('bearerToken');
    localStorage.removeItem('selectedOrgId');
  
    setIsLoggedIn(false);
    setMemberName('');
    setAuthToken('');
    setApiKey('');
    setBearerToken('');
    setSelectedOrg(null);
    setLoginStep(0);
  
    message.success('You have been logged out.');
  };
  
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');
  const [memberName, setMemberName] = useState(localStorage.getItem('memberName') || '');
  const [authToken, setAuthToken] = useState(localStorage.getItem('authToken') || '');
  
  const [loginModalVisible, setLoginModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const sidebarMenuItems = [
    {
      key: 'sandbox',
      icon: <ApiOutlined style={{ fontSize: 20 }} />,
      tooltip: 'API Sandbox',
      onClick: () => {
        setActiveSection('sandbox');
        setIsRecipeMode(false);
        setIsDevMode(false);
        resetStates();
      }
    },
    // Only show Edge Functions when logged in with an organization
    ...(isLoggedIn && selectedOrg ? [{
      key: 'edge-functions',
      icon: <ThunderboltOutlined style={{ fontSize: 20 }} />,
      tooltip: 'Edge Functions',
      onClick: () => {
        setActiveSection('edge-functions');
        setIsRecipeMode(false);
        setIsDevMode(false);
        resetStates();
        // Projects will be fetched when environment is selected
      }
    }] : []),
    {
      key: 'history',
      icon: <HistoryOutlined style={{ fontSize: 20 }} />,
      tooltip: 'History',
      onClick: () => {
        setActiveSection('history');
        if (!isLoggedIn) {
          message.info('You need to log in to view and replay your request history.');
        } else {
          setHistoryModalVisible(true);
        }
      }
    },
    ...(!isProductionMode ? [
      {
        key: 'recipes',
        icon: <ExperimentOutlined style={{ fontSize: 20 }} />,
        tooltip: 'Recipes',
        onClick: () => {
          setActiveSection('recipes');
          setIsRecipeMode(true);
          setIsDevMode(false);
          setShowIntegrations(false);
          resetStates();
        }
      },
        {
          key: 'integrations',
          icon: <LinkOutlined style={{ fontSize: 20 }} />,
          tooltip: 'Integrations',
          onClick: () => {
            if (!isLoggedIn) {
              message.info('Please log in to manage integrations');
              setLoginModalVisible(true);
              // Don't set activeSection to 'integrations' if not logged in
            } else {
              setActiveSection('integrations');
              setIntegrationsModalVisible(true);
            }
          }
        }
    ] : []),
  
    {
      key: 'guide',
      icon: <ReadOutlined style={{ fontSize: 20 }} />,
      tooltip: 'Guide',
      
      onClick: () => {
        setActiveSection('guide'); 
        setHelpVisible(true);
      }
    },
    {
      key: 'specter',
      icon: <DashboardOutlined style={{ fontSize: 20 }} />,
      tooltip: 'Open Specter Console',
      onClick: () => {
        window.open('https://console.specterapp.xyz', '_blank');
      },
      
    },
    ...(!isProductionMode ? [
      {
        key: 'divider1',
        type: 'divider'
      },
      {
        key: 'manage',
        icon: <ToolOutlined style={{ fontSize: 20 }} />,
        tooltip: 'Manage APIs',
        onClick: () => {
          setActiveSection('manage');
          setIsDevMode(true);
          setIsRecipeMode(false);
          resetStates();
        }
      },
    
    ] : [])
  ];




 
  const resetStates = () => {
    setSelectedGroup(null);
    setSelectedApi(null);
    setCodeSnippet('');
    setResponse(null);
    // Reset edge function states
    setSelectedEdgeFunction(null);
    setEdgeFunctionResponse(null);
    setEdgeFunctions([]);
    setSelectedEdgeFunctionProject(null);
    setEdgeFunctionEnv(null);
    setEdgeFunctionProjects([]);
    setEdgeFunctionJwt('');
  };
  useEffect(() => {
    const handleScroll = () => {
      if (footerRef.current) {
        const footerRect = footerRef.current.getBoundingClientRect();
        if (footerRect.top < window.innerHeight) {
          const overlap = window.innerHeight - footerRect.top;
          setAskaiButtonBottom(24 + overlap);
        } else {
          setAskaiButtonBottom(24);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (helpVisible && helpContent.content) {
      hljs.highlightAll();

      const container = document.querySelector('.documentation-content');

      if (container) {
        const codeBlocks = container.querySelectorAll('pre > code');
        codeBlocks.forEach((codeBlock) => {
          if (!codeBlock.parentElement.querySelector('.copy-button')) {
            const button = document.createElement('button');
            button.className = 'copy-button';

            const copyIcon = `
              <svg
                stroke="currentColor"
                fill="currentColor"
                stroke-width="0"
                viewBox="0 0 512 512"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M464 0H144C117.49 0 96 21.49 96 48v80h48V48h320v320h-80v48h80c26.51 
                0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM368 128H48c-26.51 
                0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 
                0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm0 
                368H48V176h320v320z"></path>
              </svg>
            `;
            const checkIcon = `
              <svg
                stroke="currentColor"
                fill="currentColor"
                stroke-width="0"
                viewBox="0 0 512 512"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M173.898 439.404l-166.4-166.4 35.818-35.818 
                130.582 130.582 300.782-300.782 35.818 
                35.818-336.6 336.6z"></path>
              </svg>
            `;

            const copyButtonHTML = `
              <span class="copy-btn-icon">${copyIcon}</span>
              <span class="copy-btn-text">Copy</span>
            `;
            button.innerHTML = copyButtonHTML;

            codeBlock.parentElement.style.position = 'relative';
            button.style.position = 'absolute';
            button.style.top = '8px';
            button.style.right = '8px';

            button.onclick = () => {
              const codeToCopy = codeBlock.innerText;

              navigator.clipboard.writeText(codeToCopy).then(() => {
                console.log('Code copied to clipboard');

                const oldHTML = button.innerHTML;
                button.innerHTML = `
                  <span class="copy-btn-icon">${checkIcon}</span>
                  <span class="copy-btn-text">Copied!</span>
                `;

                setTimeout(() => {
                  button.innerHTML = oldHTML;
                }, 1500);
              });
            };

            codeBlock.parentElement.appendChild(button);
          }
        });
      }
    }
  }, [helpVisible, helpContent.content]);
  const menu = (
    <Menu style={{ backgroundColor: theme.surfaceLight, border: `1px solid ${theme.border}` }}>

      <Menu.Item key="1" title="">
        <a href="https://manual.specterapp.xyz/specter-user-manual" target="_blank" rel="noopener noreferrer" style={{ color: theme.text }}>
          Specter Manual
        </a>
      </Menu.Item>
      <Menu.Item key="2" title="">
        <a href="https://doc.specterapp.xyz" target="_blank" rel="noopener noreferrer" style={{ color: theme.text }}>
          API Documentation
        </a>
      </Menu.Item>
      <Menu.Item key="3" title="">
        <a href="https://medium.com/specter-chronicles" target="_blank" rel="noopener noreferrer" style={{ color: theme.text }}>
          Blogs
        </a>
      </Menu.Item>
      <Menu.Item key="4" title="">
        <a href="mailto:hello@specterapp.xyz" target="_blank" rel="noopener noreferrer" style={{ color: theme.text }}>
          Contact Us
        </a>
      </Menu.Item>
      <Menu.Item key="5" title="">
        <a href="https://discord.com/invite/BZSF94yg2K" target="_blank" rel="noopener noreferrer" style={{ color: theme.text }}>
          Join Discord Community
        </a>
      </Menu.Item>
      <Menu.Item key="6" title="">
        <a href="https://specter.canny.io/feedback" target="_blank" rel="noopener noreferrer" style={{ color: theme.text }}>
          Submit Feedback
        </a>
      </Menu.Item>
    </Menu>
  );

  const [tourActive, setTourActive] = useState(false);
  const [tourSteps, setTourSteps] = useState([
    {
      target: '.api-key-input',
      content: 'This is where you\'ll input your unique API key. Enter it here to authorize and securely access the API. Keep it safe!',
      placement: 'top',
    },
    {
      target: '.api-group-select',
      content: 'Choose an API group to explore the available endpoints.',
      placement: 'top',
    },
    {
      target: '.api-select',
      content: 'Now, select an API endpoint within the chosen group. Each endpoint offers a specific action or resource you can use in your application.',
      placement: 'top',
    },
    {
      target: '.code-snippet-section',
      content: 'Here, you\'ll see sample code tailored to your selected API request, ready for you to copy and integrate into your app.',
      placement: 'top',
    },
    {
      target: '.response-section',
      content: 'Here\'s where you\'ll see the response data after making a request. It\'s perfect for verifying your API call results and ensuring everything works as expected.',
      placement: 'top',
    },
  ]);

  const fetchGroups = async () => {
    try {
      const response = await apiClient.get(`${API_BASE_URL}/groups`);
      setGroupOptions(response.data);
    } catch (error) {
      message.error('Failed to fetch API groups');
    }
  };
  
  useEffect(() => {
    fetchGroups();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setTourSteps((steps) => [...steps]);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const hasCompletedTour = localStorage.getItem('hasCompletedTour');

    if (!hasCompletedTour) {
      const timer = setTimeout(() => {
        setTourActive(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleJoyrideCallback = (data) => {
    const { status } = data;

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      localStorage.setItem('hasCompletedTour', 'true');
      setTourActive(false);
    }
  };

  const handleRunRecipe = (recipe) => {
    setIsRunningRecipe(true);
    setRunningRecipeData(recipe);
  };

  const handleCloseRunner = () => {
    setIsRunningRecipe(false);
    setRunningRecipeData(null);
  };

  const fetchDocumentationTopics = async () => {
    try {
      const response = await apiClient.get(`${API_BASE_URL}/documentation`);
      const sorted = response.data.sort((a, b) => a.sortOrder - b.sortOrder);
      setDocumentationTopics(sorted);
      setFilteredDocs(sorted);
      if (sorted.length > 0 && !selectedDoc) {
        setSelectedDoc(sorted[0]);
        setHelpContent({ title: sorted[0].title, content: sorted[0].content });
      }
    } catch (error) {
      message.error("Failed to fetch documentation");
    }
  };

  useEffect(() => {
    if (helpVisible) {
      fetchDocumentationTopics();
    }
  }, [helpVisible]);

  useEffect(() => {
    if (!docSearchQuery.trim()) {
      setFilteredDocs(documentationTopics);
    } else {
      const lowerCaseQuery = docSearchQuery.toLowerCase();
      const filtered = documentationTopics.filter(doc =>
        doc.title.toLowerCase().includes(lowerCaseQuery) ||
        doc.category.toLowerCase().includes(lowerCaseQuery) ||
        (doc.tags && doc.tags.some(tag => tag.toLowerCase().includes(lowerCaseQuery)))
      );
      setFilteredDocs(filtered);
    }
  }, [docSearchQuery, documentationTopics]);
  
  const openDocumentation = (doc) => {
    setSelectedDoc(doc);
    setHelpContent({ title: doc.title, content: doc.content });
  };

  const handleLoadRequestFromHistory = (historyItem) => {
    let foundApi = null;
    for (const groupObj of apiGroups) {
      const found = groupObj.apis.find(a => a.name === historyItem.selectedApi);
      if (found) {
        foundApi = found;
        setSelectedGroup(groupObj.group);
        break;
      }
    }
  
    if (!foundApi) {
      message.error('Unable to find the selected API in configurations.');
      return;
    }
  
    setSelectedApi(foundApi);
    setRequestParams(historyItem.requestData || {});
    setHistoryModalVisible(false);
    setActiveSection('sandbox');
  };

  const toggleRecipeMode = () => {
    const newRecipeMode = !isRecipeMode;
    setIsRecipeMode(newRecipeMode);
    
    if (newRecipeMode) {
      setIsDevMode(false);
      setSelectedGroup(null);
      setSelectedApi(null);
      setIsAddingApi(false);
      setIsEditingApi(false);
      setEditingApiData(null);
      setCodeSnippet('');
      setResponse(null);
    }
    setIsRecipeMode(!isRecipeMode);
    setIsAddingRecipe(false);
    setIsEditingRecipe(false);
    setEditingRecipeData(null);
  };

  const handleAddRecipe = () => {
    // This won't be called in sandbox mode
    message.info('Please use API Manager to create recipes');
  };

  const handleEditRecipe = (recipeData) => {
    // This won't be called in sandbox mode
    message.info('Please use API Manager to edit recipes');
  };
  
  const handleRecipeSubmit = async (values) => {
    try {
      if (isEditingRecipe && editingRecipeData?._id) {
        await apiClient.put(`${API_BASE_URL}/recipes/${editingRecipeData._id}`, values);
        message.success('Recipe updated successfully');
      } else {
        await apiClient.post(`${API_BASE_URL}/recipes`, values);
        message.success('Recipe created successfully');
      }
      setIsAddingRecipe(false);
      setIsEditingRecipe(false);
      setEditingRecipeData(null);
    } catch (error) {
      console.error('Error saving recipe:', error);
      message.error('Failed to save recipe');
    }
  };

  const handleRecipeCancel = () => {
    setIsAddingRecipe(false);
    setIsEditingRecipe(false);
    setEditingRecipeData(null);
  };

  useEffect(() => {
    if (prevIsDevModeRef.current === true && isDevMode === false && !selectedGroup) {
      message.info('Please reselect the API group to see the latest updates.');
    }
    prevIsDevModeRef.current = isDevMode;
  }, [isDevMode, selectedGroup]);

  const toggleShowCredentials = () => {
    setShowCredentials(!showCredentials);
  };

  const toggleShowDevServerCredentials = () => {
    setShowDevServerCredentials(!showDevServerCredentials);
  };

  const handleSaveDevIp = () => {
    localStorage.setItem('devIp', devIp);
    message.success('Development Server URL saved');
  };

  useEffect(() => {
    fetchApiGroups();
  }, []);
  const fetchApiGroups = async () => {
    try {
      // Fetch all APIs with pagination support
      // Set a high pageSize to get all APIs (you can adjust this based on your needs)
      const response = await apiClient.get(`${API_BASE_URL}/config`, {
        params: {
          pageSize: 1000, // Adjust based on your maximum expected APIs
          includeDetails: true // Include all details since we need them for the UI
        },
        headers: {
          'Cache-Control': 'no-cache', // Bypass cache
          'Pragma': 'no-cache'
        }
      });
      
      // Handle both paginated and non-paginated responses
      const apiData = response.data.data || response.data;
      
      const groupedApis = {};
      apiData.forEach((apiConfig) => {
        const groupName = apiConfig.group;
        if (!groupedApis[groupName]) {
          groupedApis[groupName] = [];
        }
        groupedApis[groupName].push(apiConfig);
      });
      
      const apiGroupsArray = Object.keys(groupedApis).map((groupName) => ({
        group: groupName,
        apis: groupedApis[groupName].sort((a, b) => {
          if (a.groupSortOrder != null && b.groupSortOrder != null) {
            return a.groupSortOrder - b.groupSortOrder;
          }
          return a.name.localeCompare(b.name);
        }),
      }));
      
      setApiGroups(apiGroupsArray);
    } catch (error) {
      console.error('Error fetching API groups:', error);
      message.error('Failed to fetch API groups');
    }
  };

  // Edge Functions helper functions
  // Get admin API base URL based on global environment (from localStorage)
  const getAdminBaseUrl = () => {
    const globalEnv = localStorage.getItem('selectedEnv') || 'console';
    if (globalEnv === 'staging') {
      return 'https://admin.staging.specterapp.xyz';
    }
    // production/console/demo
    return 'https://admin.specterapp.xyz';
  };

  // Get ORG API key based on selected edge function environment (appEnv)
  const getOrgApiKeyForEnv = (env) => {
    if (!selectedOrg?.id || !orgApiKeys[selectedOrg.id]) return '';
    const keys = orgApiKeys[selectedOrg.id];

    if (env === 'development') {
      return keys.devAPIKey || '';
    } else if (env === 'staging') {
      return keys.stagingAPIKey || '';
    } else if (env === 'production') {
      return keys.productionAPIKey || '';
    }
    // Default to dev if no env specified
    return keys.devAPIKey || '';
  };

  // Build headers for edge function admin API calls using appEnv (not global selectedEnv)
  const buildEdgeFunctionHeaders = (appEnv) => {
    const authToken = localStorage.getItem('authToken');
    const apiKeyForEnv = getOrgApiKeyForEnv(appEnv);

    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
      'Api-Key': apiKeyForEnv,
      'env': appEnv || 'development'
    };
  };

  const fetchEdgeFunctionProjects = async (orgId, appEnv) => {
    if (!orgId) return;
    setEdgeFunctionProjectsLoading(true);
    try {
      // Use axios directly (NOT authAxios) to avoid interceptor overwriting headers
      const headers = buildEdgeFunctionHeaders(appEnv);
      const response = await axios.post(`${getAdminBaseUrl()}/v1/app/get`, {
        organisationId: orgId
      }, { headers });
      if (response.data?.status === 'success' && response.data?.data?.projectDetails) {
        const projects = response.data.data.projectDetails;
        setEdgeFunctionProjects(projects);
      }
    } catch (error) {
      console.error('Error fetching projects:', error);
      message.error('Failed to fetch projects');
    } finally {
      setEdgeFunctionProjectsLoading(false);
    }
  };

  // Handle edge function environment selection
  const handleEdgeFunctionEnvSelect = (appEnv) => {
    setEdgeFunctionEnv(appEnv);
    // Reset project and function selections when environment changes
    setSelectedEdgeFunctionProject(null);
    setSelectedEdgeFunction(null);
    setEdgeFunctions([]);
    setEdgeFunctionJwt('');
    setEdgeFunctionResponse(null);
    // Fetch projects with the selected appEnv's API key
    if (selectedOrg?.id) {
      fetchEdgeFunctionProjects(selectedOrg.id, appEnv);
    }
  };

  const fetchEdgeFunctions = async (projectId, appEnv) => {
    if (!projectId) return;
    const envToUse = appEnv || edgeFunctionEnv || 'development';
    setEdgeFunctionsLoading(true);
    try {
      // Use axios directly (NOT authAxios) to avoid interceptor overwriting headers
      const headers = buildEdgeFunctionHeaders(envToUse);
      const response = await axios.post(`${getAdminBaseUrl()}/v2/admin/edge-functions/get`, {
        projectId: projectId,
        status: 'deployed',
        limit: 100,
        offset: 0
      }, { headers });
      if (response.data?.data) {
        // API returns { data: { functions: [...] } }
        const functions = response.data.data.functions || [];
        setEdgeFunctions(Array.isArray(functions) ? functions : []);
      }
    } catch (error) {
      console.error('Error fetching edge functions:', error);
      message.error('Failed to fetch edge functions');
    } finally {
      setEdgeFunctionsLoading(false);
    }
  };

  const fetchEdgeFunctionJwt = async (projectId, appEnv) => {
    if (!projectId) return;
    const envToUse = appEnv || edgeFunctionEnv || 'development';
    try {
      // Use axios directly (NOT authAxios) to avoid interceptor overwriting headers
      const headers = buildEdgeFunctionHeaders(envToUse);
      const response = await axios.post(`${getAdminBaseUrl()}/v2/admin/edge-functions/jwt/get`, {
        projectId: projectId
      }, { headers });
      console.log('JWT API Response:', response.data);
      // Handle different response structures
      const jwtData = response.data?.data;
      const jwt = jwtData?.jwt || jwtData?.token || (typeof jwtData === 'string' ? jwtData : '');
      if (jwt) {
        setEdgeFunctionJwt(jwt);
      }
    } catch (error) {
      console.error('Error fetching edge function JWT:', error);
      message.error('Failed to fetch edge function JWT');
    }
  };

  const handleEdgeFunctionProjectSelect = (project) => {
    setSelectedEdgeFunctionProject(project);
    localStorage.setItem('selectedEdgeFunctionProject', project.id);
    setSelectedEdgeFunction(null);
    setEdgeFunctionResponse(null);
    fetchEdgeFunctions(project.id);
    fetchEdgeFunctionJwt(project.id);
  };

  const handleRunEdgeFunction = async (functionData) => {
    const { denoUrl, edgeJwt, apiKey: funcApiKey, playerToken, payload, customHeaders = {} } = functionData;

    if (!denoUrl || !edgeJwt) {
      message.error('Missing function URL or JWT');
      return;
    }

    setEdgeFunctionLoading(true);
    setEdgeFunctionResponse(null);

    try {
      const result = await invokeEdgeFunction({
        denoUrl,
        edgeJwt,
        apiKey: funcApiKey,
        playerToken,
        payload,
        customHeaders,
      });

      setEdgeFunctionResponse(result);

      if (result.success) {
        message.success('Function executed successfully');
      } else {
        message.warning(`Function returned ${result.status}`);
      }
    } catch (error) {
      console.error('Edge function error:', error);

      setEdgeFunctionResponse({
        success: false,
        status: 0,
        statusText: 'Network Error',
        data: { error: error.message },
        headers: {},
        responseTime: 0,
        error: error.message,
      });

      message.error('Failed to execute edge function: ' + error.message);
    } finally {
      setEdgeFunctionLoading(false);
    }
  };

  const handlePreviewRequest = (params) => {
    setRequestParams(params);
    generateRequestCodeSnippet(selectedApi.route, params, selectedLanguage, selectedApi);
  };

  const showHelpDrawer = () => {
    setHelpVisible(true);
  };
  
  const handleSaveCredentials = async () => {
    if (!apiKey && !bearerToken) {
      message.error('Please enter at least one of API Key or Bearer Token');
      return;
    }
    
    setSaveStatus('saving');
    
    setTimeout(() => {
      if (apiKey) {
        localStorage.setItem('apiKey', apiKey);
      } else {
        localStorage.removeItem('apiKey');
      }
      
      if (bearerToken) {
        localStorage.setItem('bearerToken', bearerToken);
      } else {
        localStorage.removeItem('bearerToken');
      }
  
      setHasUnsavedChanges(false);
      setSaveStatus('saved');
      message.success('API Credentials saved');
    }, 300);
  };

  const handleGroupChange = (value) => {
    setSelectedGroup(value);
    setSelectedApi(null);
  };

  const handleApiChange = (value) => {
    const group = apiGroups.find((group) => group.group === selectedGroup);
    const apiDetails = group ? group.apis.find((api) => api.name === value) : null;

    setSelectedApi(apiDetails);
    setRequestParams({});
    setCodeSnippet('');
    setResponse(null);
  };

  const toggleEditorSize = () => {
    setEditorExpanded(!editorExpanded);
  };

  const toggleRequestSize = () => {
    setIsRequestExpanded(!isRequestExpanded);
  };
  
  const saveRequestHistory = async (entry) => {
    try {
      await apiClient.post(`${API_BASE_URL}/history`, entry);
      console.log('Request history saved');
    } catch (error) {
      console.error('Failed to save request history:', error);
    }
  };

  const handleRunRequest = async (params) => {
    setRequestParams(params);
    const startTime = Date.now();
    
    try {
      if (selectedApi && selectedApi.route) {
        const requestData = { ...params };
        console.log('Making API call with:', requestData);

        const response = await apiService(selectedApi.route, requestData, selectedEnv, devIp, selectedApi);
        console.log('API Service Response:', response);
        
        const endTime = Date.now();
        const responseTime = endTime - startTime;

        if (response && response.status >= 200 && response.status < 300) {
          console.log('Successful API Response:', response.data);
          setResponse(response.data);
          generateRequestCodeSnippet(selectedApi.route, requestData, selectedLanguage, selectedApi);
          message.success('API request completed successfully!');
          
          const historyEntry = {
            memberName,
            authToken,
            apiKey: localStorage.getItem('apiKey') || '',
            bearerToken: localStorage.getItem('bearerToken') || '',
            selectedEnv,
            devIp,
            selectedGroup,
            selectedApi: selectedApi.name,
            requestData: requestData,
            responseData: response.data,
            responseTime: responseTime,
            timestamp: Date.now()
          };
          
          saveRequestHistory(historyEntry);
        } else {
          const historyEntry = {
            memberName,
            authToken,
            apiKey: localStorage.getItem('apiKey') || '',
            bearerToken: localStorage.getItem('bearerToken') || '',
            selectedEnv,
            devIp,
            selectedGroup,
            selectedApi: selectedApi.name,
            requestData: requestData,
            responseData: response?.data || { error: 'Unexpected API response' },
            responseTime: responseTime,
            timestamp: Date.now()
          };
          
          saveRequestHistory(historyEntry);
          console.error('Unexpected API Response:', response);
          setResponse({ error: 'Unexpected API response received.' });
          message.error(`API request failed with status: ${response?.status} ${response?.statusText}`);
        }
      } else {
        setResponse({ error: 'API route not found. Please select a valid API.' });
        message.error('API route not found. Please select a valid API.');
      }
    } catch (error) {
      console.error('Error during API call:', error);
      
      const endTime = Date.now();
      const responseTime = endTime - startTime;
      
      const historyEntry = {
        memberName,
        authToken,
        apiKey: localStorage.getItem('apiKey') || '',
        bearerToken: localStorage.getItem('bearerToken') || '',
        selectedEnv,
        devIp,
        selectedGroup,
        selectedApi: selectedApi.name,
        requestData: params,
        responseData: error.data || { error: error.message || 'Failed to fetch data' },
        responseTime: responseTime,
        timestamp: Date.now()
      };
      
      saveRequestHistory(historyEntry);

      if (error.data) {
        setResponse(error.data);
      } else {
        setResponse({ error: 'Failed to fetch data' });
      }

      message.error(`Failed to fetch data: ${error.message}`);
    }
  };

  const generateRequestCodeSnippet = (route, params, language, selectedApi) => {
    if (!selectedApi) {
      setCodeSnippet('// Please select an API to generate code snippet.');
      return;
    }
  
    let snippet = '';
  
    const apiKeyFromStorage = localStorage.getItem('apiKey') || 'your-api-key';
    const bearerTokenFromStorage = localStorage.getItem('bearerToken');
  
    const { query = {}, path = {}, headers = {}, body = {}, formData = {}, attributes = [] } = params;
  
    let url = SPECTER_ENV_URL +route;
    for (const [key, value] of Object.entries(path)) {
      url = url.replace(`:${key}`, encodeURIComponent(value));
    }
  
    const queryString = new URLSearchParams(query).toString();
    if (queryString) {
      url += `?${queryString}`;
    }
  
    const allHeaders = {
      'Content-Type': 'application/json',
      'Api-Key': apiKeyFromStorage,
      ...(bearerTokenFromStorage ? { 'Authorization': `Bearer ${bearerTokenFromStorage}` } : {}),
      ...headers,
    };
  
    let requestBody = {};
    if (Object.keys(formData).length > 0) {
      requestBody = formData;
    } else if (Object.keys(body).length > 0) {
      requestBody = body;
    }
  
    if (attributes.length > 0) {
      if (Object.keys(requestBody).length === 0) {
        requestBody = {};
      }
      requestBody.attributes = attributes;
    }
  
    switch (language) {
      case 'Node':
        if (Object.keys(formData).length > 0) {
          snippet = generateNodeFormDataSnippet(url, allHeaders, formData, selectedApi);
        } else {
          snippet = generateNodeSnippet(url, allHeaders, requestBody, selectedApi);
        }
        break;
      case 'Python':
        if (Object.keys(formData).length > 0) {
          snippet = generatePythonFormDataSnippet(url, allHeaders, formData, selectedApi);
        } else {
          snippet = generatePythonSnippet(url, allHeaders, requestBody, selectedApi);
        }
        break;
      case 'cURL':
        snippet = generateCurlSnippet(url, allHeaders, requestBody, formData, selectedApi);
        break;
      case 'C#':
        snippet = generateCSharpSnippet(url, allHeaders, requestBody, formData, selectedApi);
        break;
      case 'Unity C#':
        snippet = generateUnityCSharpSnippet(url, allHeaders, requestBody, formData, selectedApi);
        break;
      case 'C++':
        snippet = generateCppSnippet(url, allHeaders, requestBody, formData, selectedApi);
        break;
      case 'Unreal C++':
        snippet = generateUnrealCppSnippet(url, allHeaders, requestBody, formData, selectedApi);
        break;
      case 'Java':
        snippet = generateJavaSnippet(url, allHeaders, requestBody, formData, selectedApi);
        break;
      case 'Go':
        snippet = generateGoSnippet(url, allHeaders, requestBody, formData, selectedApi);
        break;
      case 'PHP':
        snippet = generatePHPSnippet(url, allHeaders, requestBody, formData, selectedApi);
        break;
      case 'Ruby':
        snippet = generateRubySnippet(url, allHeaders, requestBody, formData, selectedApi);
        break;
      case 'Swift':
        snippet = generateSwiftSnippet(url, allHeaders, requestBody, formData, selectedApi);
        break;

case 'TypeScript':
  snippet = generateTypeScriptSnippet(url, allHeaders, requestBody, selectedApi);
  break;
case 'Kotlin':
  snippet = generateKotlinSnippet(url, allHeaders, requestBody, formData, selectedApi);
  break;
case 'Lua':
  snippet = generateLuaSnippet(url, allHeaders, requestBody, selectedApi);
  break;
case 'GDScript':
  snippet = generateGDScriptSnippet(url, allHeaders, requestBody, selectedApi);
  break;
case 'Rust':
  snippet = generateRustSnippet(url, allHeaders, requestBody, selectedApi);
  break;
case 'Dart':
  snippet = generateDartSnippet(url, allHeaders, requestBody, selectedApi);
  break;
case 'Shell':
  snippet = generateShellSnippet(url, allHeaders, requestBody, selectedApi);
  break;
case 'PowerShell':
  snippet = generatePowerShellSnippet(url, allHeaders, requestBody, selectedApi);
  break;
      default:
        snippet = '// Select a language to generate code';
    }
  
    setCodeSnippet(snippet);
  };
  
  const generateNodeSnippet = (url, headers, requestBody, selectedApi) => {
    const method = selectedApi?.method?.toLowerCase() || 'get';
    return `const axios = require('axios');


axios.${selectedApi.method.toLowerCase()}('${url}', ${JSON.stringify(requestBody, null, 2)}, {
  headers: ${JSON.stringify(headers, null, 2)},
})
.then(response => console.log(response.data))
.catch(error => console.error('Error:', error));`;
  };

  const generateNodeFormDataSnippet = (url, headers, formData, selectedApi) => {
    return `const axios = require('axios');
const FormData = require('form-data');
const fs = require('fs');

const form = new FormData();
${Object.entries(formData)
    .map(([key, value]) => {
      if (value && value.filepath) {
        return `form.append('${key}', fs.createReadStream('${value.filepath}'));`;
      } else {
        return `form.append('${key}', '${value}');`;
      }
    })
    .join('\n')}

axios({
  method: '${selectedApi.method.toLowerCase()}',
  url: '${url}',
  headers: {
    ...form.getHeaders(),
    ${Object.entries(headers)
      .map(([key, value]) => `'${key}': '${value}'`)
      .join(',\n    ')}
  },
  data: form,
})
.then(response => console.log(response.data))
.catch(error => console.error('Error:', error));`;
  };

  const generatePythonSnippet = (url, headers, requestBody, selectedApi) => {
    return `import requests

url = '${url}'
headers = ${JSON.stringify(headers, null, 2)}

payload = ${JSON.stringify(requestBody, null, 2)}

try:
  response = requests.${selectedApi.method.toLowerCase()}(url, json=payload, headers=headers)
  response.raise_for_status()
  print(response.json())
except requests.exceptions.HTTPError as http_err:
  print(f"HTTP error occurred: {http_err}")
except Exception as err:
  print(f"Other error occurred: {err}")`;
  };

  const generatePythonFormDataSnippet = (url, headers, formData, selectedApi) => {
    return `import requests

url = '${url}'
headers = ${JSON.stringify(headers, null, 2)}

files = {
  ${Object.entries(formData)
    .map(([key, value]) => {
      if (value && value.filepath) {
        return `'${key}': open('${value.filepath}', 'rb')`;
      } else {
        return `'${key}': (None, '${value}')`;
      }
    })
    .join(',\n  ')}
}

try:
  response = requests.${selectedApi.method.toLowerCase()}(url, files=files, headers=headers)
  response.raise_for_status()
  print(response.json())
except requests.exceptions.HTTPError as http_err:
  print(f"HTTP error occurred: {http_err}")
except Exception as err:
  print(f"Other error occurred: {err}")`;
  };

  const generateCppSnippet = (url, headers, requestBody, formData, selectedApi) => {
    if (Object.keys(formData).length > 0) {
      return `#include <iostream>
#include <string>
#include <future>
#include <httplib.h>  // Include the cpp-httplib library

int main() {
  // Parse URL to extract host and path
  std::string url = "${url}";
  
  // Extract scheme, host, and path from URL
  std::string scheme = url.substr(0, url.find("://"));
  std::string hostWithPath = url.substr(url.find("://") + 3);
  std::string host = hostWithPath.substr(0, hostWithPath.find("/"));
  std::string path = hostWithPath.substr(hostWithPath.find("/"));
  
  // Create the appropriate client based on the scheme
  httplib::SSLClient client(host);  // Using SSLClient for HTTPS
  
  // Prepare headers
  httplib::Headers headers = {
${Object.entries(headers)
  .map(([key, value]) => `    {"${key}", "${value}"}`)
  .join(',\n')}
  };
  
  // Prepare multipart form data
  httplib::MultipartFormDataItems items;
${Object.entries(formData)
  .map(([key, value]) => {
    if (value && value.filepath) {
      return `  // Add file content for ${key}
  std::ifstream file("${value.filepath}", std::ios::binary);
  if (file) {
    std::string file_content((std::istreambuf_iterator<char>(file)), 
                            std::istreambuf_iterator<char>());
    items.push_back({"${key}", file_content, "${value.filename || 'file'}", "application/octet-stream"});
  }`;
    } else {
      return `  items.push_back({"${key}", "${value}", "", ""});`;
    }
  })
  .join('\n')}
  
  // Create a future to execute the request asynchronously
  auto requestFuture = std::async(std::launch::async, [&]() {
    return client.${selectedApi.method.toLowerCase().charAt(0).toUpperCase() + selectedApi.method.toLowerCase().slice(1)}(path, headers, items);
  });
  
  // Wait for the request to complete
  std::cout << "Sending ${selectedApi.method.toUpperCase()} request..." << std::endl;
  auto result = requestFuture.get();
  
  // Process the response
  if (result) {
    std::cout << "Status: " << result->status << std::endl;
    std::cout << "Response body:" << std::endl << result->body << std::endl;
  } else {
    std::cerr << "Request failed" << std::endl;
  }
  
  return 0;
}`;
    } else {
      return `#include <iostream>
#include <string>
#include <future>
#include <httplib.h>  // Include the cpp-httplib library
#include <nlohmann/json.hpp>  // Include the nlohmann/json library

using json = nlohmann::json;

int main() {
  // Parse URL to extract host and path
  std::string url = "${url}";
  
  // Extract scheme, host, and path from URL
  std::string scheme = url.substr(0, url.find("://"));
  std::string hostWithPath = url.substr(url.find("://") + 3);
  std::string host = hostWithPath.substr(0, hostWithPath.find("/"));
  std::string path = hostWithPath.substr(hostWithPath.find("/"));
  
  // Create the appropriate client for HTTPS
  httplib::SSLClient client(host);
  
  // Prepare headers
  httplib::Headers headers = {
${Object.entries(headers)
  .map(([key, value]) => `    {"${key}", "${value}"}`)
  .join(',\n')}
  };
  
  // Prepare request body as JSON
  json requestBody = ${JSON.stringify(requestBody, null, 2).length > 0 
    ? `json::parse(R"(${JSON.stringify(requestBody, null, 2)})")`
    : 'json::object()'};
  
  std::string body = requestBody.dump();
  
  // Create a future to execute the request asynchronously
  auto requestFuture = std::async(std::launch::async, [&]() {
    return client.${selectedApi.method.toLowerCase().charAt(0).toUpperCase() + selectedApi.method.toLowerCase().slice(1)}(path, headers, body, "application/json");
  });
  
  // Wait for the request to complete
  std::cout << "Sending ${selectedApi.method.toUpperCase()} request..." << std::endl;
  auto result = requestFuture.get();
  
  // Process the response
  if (result) {
    std::cout << "Status: " << result->status << std::endl;
    
    // Try to parse the response as JSON
    try {
      auto responseJson = json::parse(result->body);
      std::cout << "Response body:" << std::endl;
      std::cout << responseJson.dump(2) << std::endl;
    } catch (json::parse_error&) {
      // If not valid JSON, just print the raw response
      std::cout << "Response body:" << std::endl << result->body << std::endl;
    }
  } else {
    std::cerr << "Request failed" << std::endl;
  }
  
  return 0;
}`;
    }
  };

  const generateCurlSnippet = (url, headers, requestBody, formData, selectedApi) => {
    const method = selectedApi?.method?.toUpperCase() || 'GET';

    let curlHeaders = '';
    for (const [key, value] of Object.entries(headers)) {
      curlHeaders += `-H '${key}: ${value}' \\\n`;
    }

    if (Object.keys(formData).length > 0) {
      let curlFormData = '';
      for (const [key, value] of Object.entries(formData)) {
        if (value && value.filepath) {
          curlFormData += `-F '${key}=@${value.filepath}' \\\n`;
        } else {
          curlFormData += `-F '${key}=${value}' \\\n`;
        }
      }
      return `curl -X ${method} '${url}' \\\n${curlHeaders}${curlFormData}`;
    } else {
      let curlData = `-d '${JSON.stringify(requestBody, null, 2)}'`;
      return `curl -X ${method} '${url}' \\\n${curlHeaders}${curlData}`;
    }
  };

  const generateUnityCSharpSnippet = (url, headers, requestBody, _formData, selectedApi) => {
    const headerLines = Object.entries(headers)
      .map(([k, v]) => `request.SetRequestHeader("${k}", "${v}");`)
      .join('\n    ');

    const bodyJson = JSON.stringify(requestBody, null, 2).replace(/"/g, '\\"');

    return `using System.Collections;
using UnityEngine;
using UnityEngine.Networking;
using System.Text;

IEnumerator Call${selectedApi.name.replace(/\\W/g, "")}()
{
    var json = @"${bodyJson}";
    var request = new UnityWebRequest("${url}", UnityWebRequest.kHttpVerbPOST)
    {
        uploadHandler   = new UploadHandlerRaw(Encoding.UTF8.GetBytes(json)),
        downloadHandler = new DownloadHandlerBuffer()
    };
    request.SetRequestHeader("Content-Type", "application/json");
    ${headerLines}

    yield return request.SendWebRequest();

    if (request.result == UnityWebRequest.Result.Success)
        Debug.Log(request.downloadHandler.text);
    else
        Debug.LogError($"HTTP {request.responseCode}: {request.error}");
}`;
  };

  const generateCSharpSnippet = (url, headers, requestBody, formData, selectedApi) => {
    if (Object.keys(formData).length > 0) {
      return `using System.Net.Http;
using System.Net.Http.Headers;
using System.Threading.Tasks;

var client = new HttpClient();
var url = "${url}";
var form = new MultipartFormDataContent();

${Object.entries(formData)
      .map(([key, value]) => {
        if (value && value.filepath) {
          return `form.Add(new StreamContent(File.OpenRead("${value.filepath}")), "${key}", "${value.filename ?? 'file'}");`;
        } else {
          return `form.Add(new StringContent("${value}"), "${key}");`;
        }
      })
      .join('\n')}

${Object.entries(headers)
      .map(([key, value]) => `client.DefaultRequestHeaders.Add("${key}", "${value}");`)
      .join('\n')}

var response = await client.${selectedApi.method.toLowerCase()}Async(url, form);
var responseBody = await response.Content.ReadAsStringAsync();
Console.WriteLine(responseBody);`;
    } else {
      return `using System.Net.Http;
using System.Text;
using Newtonsoft.Json;

var client = new HttpClient();
var url = "${url}";
var requestBody = JsonConvert.SerializeObject(${JSON.stringify(requestBody, null, 2)});
var content = new StringContent(requestBody, Encoding.UTF8, "application/json");
${Object.entries(headers)
      .map(([key, value]) => `client.DefaultRequestHeaders.Add("${key}", "${value}");`)
      .join('\n')}
var response = await client.${selectedApi.method.toLowerCase()}Async(url, content);
var responseBody = await response.Content.ReadAsStringAsync();
Console.WriteLine(responseBody);`;
    }
  };

  const generateGoSnippet = (url, headers, requestBody, formData, selectedApi) => {
    if (Object.keys(formData).length > 0) {
      return `package main

import (
  "bytes"
  "fmt"
  "mime/multipart"
  "net/http"
  "os"
)

func main() {
  url := "${url}"
  var b bytes.Buffer
  w := multipart.NewWriter(&b)

  ${Object.entries(formData)
      .map(([key, value]) => {
        if (value && value.filepath) {
          return `file, _ := os.Open("${value.filepath}")
  defer file.Close()
  fw, _ := w.CreateFormFile("${key}", "${value.filename ?? 'file'}")
  io.Copy(fw, file)`;
        } else {
          return `w.WriteField("${key}", "${value}")`;
        }
      })
      .join('\n  ')}

  w.Close()

  req, _ := http.NewRequest("${selectedApi.method.toUpperCase()}", url, &b)
  req.Header.Set("Content-Type", w.FormDataContentType())
  ${Object.entries(headers)
      .map(([key, value]) => `req.Header.Set("${key}", "${value}")`)
      .join('\n  ')}

  client := &http.Client{}
  resp, err := client.Do(req)
  if (err != nil) {
    panic(err)
  }
  defer resp.Body.Close()
  fmt.Println("Response status:", resp.Status)
}`;
    } else {
      return `package main

import (
  "bytes"
  "fmt"
  "net/http"
)

func main() {
  url := "${url}"
  var jsonStr = []byte(\`${JSON.stringify(requestBody, null, 2)}\`)

  req, err := http.NewRequest("${selectedApi.method.toUpperCase()}", url, bytes.NewBuffer(jsonStr))
  req.Header.Set("Content-Type", "application/json")
  ${Object.entries(headers)
      .map(([key, value]) => `req.Header.Set("${key}", "${value}")`)
      .join('\n  ')}

  client := &http.Client{}
  resp, err := client.Do(req)
  if (err != nil) {
    panic(err)
  }
  defer resp.Body.Close()
  fmt.Println("Response status:", resp.Status)
}`;
    }
  };

  const generatePHPSnippet = (url, headers, requestBody, formData, selectedApi) => {
    if (Object.keys(formData).length > 0) {
      return `<?php

$curl = curl_init();

curl_setopt_array($curl, array(
  CURLOPT_URL => "${url}",
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_ENCODING => "",
  CURLOPT_MAXREDIRS => 10,
  CURLOPT_TIMEOUT => 30,
  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
  CURLOPT_CUSTOMREQUEST => "${selectedApi.method.toUpperCase()}",
  CURLOPT_POSTFIELDS => http_build_query(${JSON.stringify(formData, null, 2)}),
  CURLOPT_HTTPHEADER => array(
    ${Object.entries(headers)
      .map(([key, value]) => `"${key}: ${value}"`)
      .join(',\n    ')}
  ),
));

$response = curl_exec($curl);
$err = curl_error($curl);

curl_close($curl);

if ($err) {
  echo "cURL Error #: " . $err;
} else {
  echo $response;
}
?>`;
    } else {
      return `<?php

$curl = curl_init();

curl_setopt_array($curl, array(
  CURLOPT_URL => "${url}",
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_ENCODING => "",
  CURLOPT_MAXREDIRS => 10,
  CURLOPT_TIMEOUT => 30,
  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
  CURLOPT_CUSTOMREQUEST => "${selectedApi.method.toUpperCase()}",
  CURLOPT_POSTFIELDS => json_encode(${JSON.stringify(requestBody, null, 2)}),
  CURLOPT_HTTPHEADER => array(
    "Content-Type: application/json",
    ${Object.entries(headers)
      .map(([key, value]) => `"${key}: ${value}"`)
      .join(',\n    ')}
  ),
));

$response = curl_exec($curl);
$err = curl_error($curl);

curl_close($curl);

if ($err) {
  echo "cURL Error #: " . $err;
} else {
  echo $response;
}
?>`;
    }
  };

  const generateRubySnippet = (url, headers, requestBody, formData, selectedApi) => {
    if (Object.keys(formData).length > 0) {
      return `require 'net/http'
require 'uri'

uri = URI.parse('${url}')
request = Net::HTTP::${selectedApi.method.charAt(0).toUpperCase() + selectedApi.method.slice(1).toLowerCase()}.new(uri)
${Object.entries(headers)
      .map(([key, value]) => `request['${key}'] = '${value}'`)
      .join('\n')}

form_data = [
  ${Object.entries(formData)
      .map(([key, value]) => {
        if (value && value.filepath) {
          return `['${key}', File.open('${value.filepath}')]`;
        } else {
          return `['${key}', '${value}']`;
        }
      })
      .join(',\n  ')}
]

request.set_form form_data, 'multipart/form-data'

req_options = {
  use_ssl: uri.scheme == 'https',
}

response = Net::HTTP.start(uri.hostname, uri.port, req_options) do |http|
  http.request(request)
end

puts response.body`;
    } else {
      return `require 'net/http'
require 'uri'
require 'json'

uri = URI.parse('${url}')
request = Net::HTTP::${selectedApi.method.charAt(0).toUpperCase() + selectedApi.method.slice(1).toLowerCase()}.new(uri)
${Object.entries(headers)
      .map(([key, value]) => `request['${key}'] = '${value}'`)
      .join('\n')}
request.content_type = 'application/json'
request.body = ${JSON.stringify(requestBody, null, 2)}.to_json

req_options = {
  use_ssl: uri.scheme == 'https',
}

response = Net::HTTP.start(uri.hostname, uri.port, req_options) do |http|
  http.request(request)
end

puts response.body`;
    }
  };

  const generateSwiftSnippet = (url, headers, requestBody, formData, selectedApi) => {
    if (Object.keys(formData).length > 0) {
      return `import Foundation
  
  let url = URL(string: "${url}")!
  var request = URLRequest(url: url)
  request.httpMethod = "${selectedApi.method.toUpperCase()}"

${Object.entries(headers)
     .map(([key, value]) => `request.addValue("${value}", forHTTPHeaderField: "${key}")`)
     .join('\n')}

let boundary = UUID().uuidString
request.setValue("multipart/form-data; boundary=\\(boundary)", forHTTPHeaderField: "Content-Type")

var body = Data()

${Object.entries(formData)
     .map(([key, value]) => {
       if (value && value.filepath) {
         return `let fileData = try Data(contentsOf: URL(fileURLWithPath: "${value.filepath}"))
body.append("--\\(boundary)\\r\\n".data(using: .utf8)!)
body.append("Content-Disposition: form-data; name=\\"${key}\\"; filename=\\"${value.filename ?? 'file'}\\"\\r\\n".data(using: .utf8)!)
body.append("Content-Type: application/octet-stream\\r\\n\\r\\n".data(using: .utf8)!)
body.append(fileData)
body.append("\\r\\n".data(using: .utf8)!)`;
       } else {
         return `body.append("--\\(boundary)\\r\\n".data(using: .utf8)!)
body.append("Content-Disposition: form-data; name=\\"${key}\\"\\r\\n\\r\\n".data(using: .utf8)!)
body.append("${value}\\r\\n".data(using: .utf8)!)`;
       }
     })
     .join('\n')}

body.append("--\\(boundary)--\\r\\n".data(using: .utf8)!)
request.httpBody = body

let task = URLSession.shared.dataTask(with: request) { data, response, error in
 guard let data = data, error == nil else { return }
 print(String(data: data, encoding: .utf8)!)
}
task.resume()`;
   } else {
     return `import Foundation

let url = URL(string: "${url}")!
var request = URLRequest(url: url)
request.httpMethod = "${selectedApi.method.toUpperCase()}"

${Object.entries(headers)
     .map(([key, value]) => `request.addValue("${value}", forHTTPHeaderField: "${key}")`)
     .join('\n')}

let json: [String: Any] = ${JSON.stringify(requestBody, null, 2)}
let jsonData = try? JSONSerialization.data(withJSONObject: json)

request.httpBody = jsonData

let task = URLSession.shared.dataTask(with: request) { data, response, error in
 guard let data = data, error == nil else { return }
 print(String(data: data, encoding: .utf8)!)
}
task.resume()`;
   }
 };

 const generateJavaSnippet = (url, headers, requestBody, formData, selectedApi) => {
   if (Object.keys(formData).length > 0) {
     return `import java.io.File;
import java.io.IOException;
import okhttp3.*;

public class Main {
 public static void main(String[] args) throws IOException {
   OkHttpClient client = new OkHttpClient();

   MultipartBody.Builder multipartBuilder = new MultipartBody.Builder().setType(MultipartBody.FORM);

   ${Object.entries(formData)
     .map(([key, value]) => {
       if (value && value.filepath) {
         return `multipartBuilder.addFormDataPart("${key}", "${value.filename ?? 'file'}",
           RequestBody.create(new File("${value.filepath}"), MediaType.parse("application/octet-stream")));`;
       } else {
         return `multipartBuilder.addFormDataPart("${key}", "${value}");`;
       }
     })
     .join('\n    ')}

   RequestBody requestBody = multipartBuilder.build();

   Request request = new Request.Builder()
     .url("${url}")
     .method("${selectedApi.method.toUpperCase()}", requestBody)
     ${Object.entries(headers)
       .map(([key, value]) => `.addHeader("${key}", "${value}")`)
       .join('\n      ')}
     .build();

   Response response = client.newCall(request).execute();
   System.out.println(response.body().string());
 }
}`;
   } else {
     return `import java.io.IOException;
import okhttp3.*;

public class Main {
 public static void main(String[] args) throws IOException {
   OkHttpClient client = new OkHttpClient();

   MediaType mediaType = MediaType.parse("application/json");
   RequestBody body = RequestBody.create(${JSON.stringify(requestBody, null, 2)}, mediaType);

   Request request = new Request.Builder()
     .url("${url}")
     .method("${selectedApi.method.toUpperCase()}", body)
     ${Object.entries(headers)
       .map(([key, value]) => `.addHeader("${key}", "${value}")`)
       .join('\n      ')}
     .build();

   Response response = client.newCall(request).execute();
   System.out.println(response.body().string());
 }
}`;
   }
 };

 

 const generateUnrealCppSnippet = (url, headers, requestBody, formData, selectedApi) => {
   const verb = selectedApi.method.toUpperCase();
   const headerLines = Object.entries(headers)
     .map(([k, v]) => `Request->SetHeader(TEXT("${k}"), TEXT("${v}"));`)
     .join('\n    ');
   const bodyJson = JSON.stringify(requestBody, null, 2);

   return `// Build.cs ➜ AddMinDependencyModuleNames("Http", "Json", "JsonUtilities")
#include "HttpModule.h"
#include "Interfaces/IHttpResponse.h"
#include "Json.h"
#include "JsonUtilities.h"

void UYourClass::Call${selectedApi.name.replace(/[^A-Za-z]/g, "")}()
{
   TSharedRef<IHttpRequest, ESPMode::ThreadSafe> Request =
       FHttpModule::Get().CreateRequest();
   Request->SetURL(TEXT("${url}"));
   Request->SetVerb(TEXT("${verb}"));
   ${headerLines || '// (no extra headers)'}
${Object.keys(formData).length
 ? '    // TODO: build multipart form data here\n'
 : `    FString Body;\n    TSharedRef<TJsonWriter<>> Writer = TJsonWriterFactory<>::Create(&Body);\n    FJsonSerializer::Serialize(MakeShared<FJsonObject>(), Writer);\n    Request->SetContentAsString(Body); /* ${bodyJson.replace(/\n/g, '')} */\n`
}

   Request->OnProcessRequestComplete().BindLambda(
       [](FHttpRequestPtr Req, FHttpResponsePtr Resp, bool bSucceeded)
       {
           if (bSucceeded && Resp->GetResponseCode() >= 200 && Resp->GetResponseCode() < 300)
           {
               UE_LOG(LogTemp, Log, TEXT("OK: %s"), *Resp->GetContentAsString());
           }
           else
           {
               UE_LOG(LogTemp, Error, TEXT("HTTP %d - %s"),
                      Resp.IsValid() ? Resp->GetResponseCode() : -1,
                      Resp.IsValid() ? *Resp->GetContentAsString() : TEXT("No Response"));
           }
       });
   Request->ProcessRequest();
}`;
 };

 const generateTypeScriptSnippet = (url, headers, requestBody, selectedApi) => {
  const method = selectedApi?.method?.toLowerCase() || 'get';
  return `import axios from 'axios';

interface ApiResponse {
  // Define your response type here
  [key: string]: any;
}

async function call${selectedApi.name.replace(/\W/g, "")}(): Promise<void> {
  try {
    const response = await axios.${method}<ApiResponse>('${url}', ${
      method === 'get' ? '' : JSON.stringify(requestBody, null, 2) + ', '
    }{
      headers: ${JSON.stringify(headers, null, 2)},
    });
    
    console.log(response.data);
  } catch (error) {
    console.error('Error:', error);
  }
}

call${selectedApi.name.replace(/\W/g, "")}();`;
};

const generateKotlinSnippet = (url, headers, requestBody, formData, selectedApi) => {
  if (Object.keys(formData).length > 0) {
    return `import okhttp3.*
import okhttp3.MediaType.Companion.toMediaType
import okhttp3.RequestBody.Companion.asRequestBody
import java.io.File

fun main() {
    val client = OkHttpClient()
    
    val requestBody = MultipartBody.Builder()
        .setType(MultipartBody.FORM)
${Object.entries(formData)
  .map(([key, value]) => {
    if (value && value.filepath) {
      return `        .addFormDataPart("${key}", "${value.filename || 'file'}", 
            File("${value.filepath}").asRequestBody("application/octet-stream".toMediaType())
        )`;
    } else {
      return `        .addFormDataPart("${key}", "${value}")`;
    }
  })
  .join('\n')}
        .build()

    val request = Request.Builder()
        .url("${url}")
        .${selectedApi.method.toLowerCase()}(requestBody)
${Object.entries(headers)
  .map(([key, value]) => `        .addHeader("${key}", "${value}")`)
  .join('\n')}
        .build()

    client.newCall(request).execute().use { response ->
        println(response.body?.string())
    }
}`;
  } else {
    return `import okhttp3.*
import okhttp3.MediaType.Companion.toMediaType
import okhttp3.RequestBody.Companion.toRequestBody

fun main() {
    val client = OkHttpClient()
    
    val mediaType = "application/json".toMediaType()
    val body = """${JSON.stringify(requestBody, null, 2)}""".toRequestBody(mediaType)
    
    val request = Request.Builder()
        .url("${url}")
        .${selectedApi.method.toLowerCase()}(body)
${Object.entries(headers)
  .map(([key, value]) => `        .addHeader("${key}", "${value}")`)
  .join('\n')}
        .build()

    client.newCall(request).execute().use { response ->
        println(response.body?.string())
    }
}`;
  }
};

const generateLuaSnippet = (url, headers, requestBody, selectedApi) => {
  return `local http = require("socket.http")
local ltn12 = require("ltn12")
local json = require("json") -- You may need a JSON library like dkjson

local request_body = json.encode(${JSON.stringify(requestBody, null, 2)})
local response_body = {}

local res, code, response_headers = http.request{
    url = "${url}",
    method = "${selectedApi.method.toUpperCase()}",
    headers = {
${Object.entries(headers)
  .map(([key, value]) => `        ["${key}"] = "${value}",`)
  .join('\n')}
        ["Content-Length"] = tostring(#request_body)
    },
    source = ltn12.source.string(request_body),
    sink = ltn12.sink.table(response_body)
}

if code == 200 then
    print(table.concat(response_body))
else
    print("HTTP Error: " .. tostring(code))
end`;
};

const generateGDScriptSnippet = (url, headers, requestBody, selectedApi) => {
  return `extends Node

func _ready():
    call_api()

func call_api():
    var http_request = HTTPRequest.new()
    add_child(http_request)
    http_request.request_completed.connect(_on_request_completed)
    
    var headers = [
${Object.entries(headers)
  .map(([key, value]) => `        "${key}: ${value}"`)
  .join(',\n')}
    ]
    
    var body = JSON.stringify(${JSON.stringify(requestBody, null, 2)})
    
    http_request.request(
        "${url}",
        headers,
        HTTPClient.${selectedApi.method.toUpperCase()},
        body
    )

func _on_request_completed(result, response_code, headers, body):
    if response_code == 200:
        var json = JSON.new()
        json.parse(body.get_string_from_utf8())
        print(json.data)
    else:
        print("Error: ", response_code)`;
};

const generateRustSnippet = (url, headers, requestBody, selectedApi) => {
  return `use reqwest;
use serde_json::json;

#[tokio::main]
async fn main() -> Result<(), Box<dyn std::error::Error>> {
    let client = reqwest::Client::new();
    
    let body = json!(${JSON.stringify(requestBody, null, 2)});
    
    let response = client
        .${selectedApi.method.toLowerCase()}("${url}")
${Object.entries(headers)
  .map(([key, value]) => `        .header("${key}", "${value}")`)
  .join('\n')}
        .json(&body)
        .send()
        .await?;
    
    let status = response.status();
    let text = response.text().await?;
    
    println!("Status: {}", status);
    println!("Response: {}", text);
    
    Ok(())
}

// Add to Cargo.toml:
// [dependencies]
// reqwest = { version = "0.11", features = ["json"] }
// tokio = { version = "1", features = ["full"] }
// serde_json = "1.0"`;
};

const generateDartSnippet = (url, headers, requestBody, selectedApi) => {
  return `import 'dart:convert';
import 'package:http/http.dart' as http;

Future<void> callApi() async {
  final url = Uri.parse('${url}');
  final headers = <String, String>${JSON.stringify(headers, null, 2)};
  final body = jsonEncode(${JSON.stringify(requestBody, null, 2)});
  
  try {
    final response = await http.${selectedApi.method.toLowerCase()}(
      url,
      headers: headers,
      body: body,
    );
    
    if (response.statusCode == 200) {
      final responseData = jsonDecode(response.body);
      print(responseData);
    } else {
      print('Request failed with status: \${response.statusCode}');
    }
  } catch (e) {
    print('Error: \$e');
  }
}

void main() {
  callApi();
}`;
};

const generateShellSnippet = (url, headers, requestBody, selectedApi) => {
  let script = `#!/bin/bash\n\n`;
  
  // Build headers
  let headerFlags = '';
  for (const [key, value] of Object.entries(headers)) {
    headerFlags += `-H "${key}: ${value}" \\\n  `;
  }
  
  // Build the curl command
  script += `curl -X ${selectedApi.method.toUpperCase()} \\\n  `;
  script += `"${url}" \\\n  `;
  script += headerFlags;
  
  if (Object.keys(requestBody).length > 0) {
    script += `-d '${JSON.stringify(requestBody)}' \\\n  `;
  }
  
  script += `| jq '.' # Optional: pipe to jq for pretty JSON output`;
  
  return script;
};

const generatePowerShellSnippet = (url, headers, requestBody, selectedApi) => {
  return `# PowerShell script to call API
$headers = @{
${Object.entries(headers)
  .map(([key, value]) => `    "${key}" = "${value}"`)
  .join('\n')}
}

$body = @'
${JSON.stringify(requestBody, null, 2)}
'@

try {
    $response = Invoke-RestMethod \`
        -Uri "${url}" \`
        -Method ${selectedApi.method.toUpperCase()} \`
        -Headers $headers \`
        -Body $body \`
        -ContentType "application/json"
    
    # Display the response
    $response | ConvertTo-Json -Depth 10
} catch {
    Write-Error "API call failed: $_"
}`;
};





 const onSelectOrg = (org) => {
   setSelectedOrg(org);
 };

 useEffect(() => {
   const storedOrgId = localStorage.getItem('selectedOrgId');
   if (storedOrgId && orgs.length > 0 && !selectedOrg) {
     const savedOrg = orgs.find(o => o.id.toString() === storedOrgId);
     if (savedOrg) {
       onSelectOrg(savedOrg);
     }
   }
 }, [orgs, selectedOrg, onSelectOrg]);


 const orgContent = (
   <List
     dataSource={orgs}
     style={{ 
       backgroundColor: theme.surfaceLight,
       borderRadius: '8px',
       border: `1px solid ${theme.border}`,
     }}
     renderItem={(org) => (
       <List.Item
         className="org-list-item"
         onClick={() => {
           onSelectOrg(org);
           localStorage.setItem('selectedOrgId', org.id);
         }}
         style={{ 
           cursor: 'pointer',
           backgroundColor: theme.surfaceLight,
           color: theme.text,
           borderBottom: `1px solid ${theme.border}`,
           padding: '12px 16px',
           transition: 'all 0.2s ease',
         }}
         onMouseEnter={(e) => {
           e.currentTarget.style.backgroundColor = theme.surface;
         }}
         onMouseLeave={(e) => {
           e.currentTarget.style.backgroundColor = theme.surfaceLight;
         }}
       >
         <List.Item.Meta
           avatar={
             <Avatar 
               style={{ 
                 backgroundColor: theme.primary,
                 color: '#ffffff',
                 fontWeight: 'bold'
               }}
             >
               {org.name.charAt(0).toUpperCase()}
             </Avatar>
           }
           title={
             <span style={{ 
               color: theme.text, 
               fontSize: '14px',
               fontWeight: '500'
             }}>
               {org.name}
             </span>
           }
         />
       </List.Item>
     )}
   />
 );

 const handleLanguageChange = (value) => {
   setSelectedLanguage(value);
   generateRequestCodeSnippet(selectedApi?.route, requestParams, value, selectedApi);
 };

 const toggleDevMode = () => {
  const newDevMode = !isDevMode;
  setIsDevMode(newDevMode);
  
  if (newDevMode) {
    setIsRecipeMode(false);
    setIsAddingRecipe(false);
    setIsEditingRecipe(false);
    setEditingRecipeData(null);
  }

  setSelectedGroup(null);
  setSelectedApi(null);
  setCodeSnippet('');
  setResponse(null);
};

 const handleCopyToClipboard = (text) => {
   navigator.clipboard.writeText(text);
   message.success('Copied to clipboard');
 };

 const handleApiSubmit = (values) => {
   if (isEditingApi) {
    apiClient
       .put(`${API_BASE_URL}/config/${editingApiData._id}`, values)
       .then((response) => {
         message.success('API updated successfully');
         fetchApiGroups();
         setIsAddingApi(false);
         setIsEditingApi(false);
         setEditingApiData(null);
       })
       .catch((error) => {
         console.error('Error updating API:', error);
         message.error('Failed to update API');
       });
   } else {
    apiClient
       .post(`${API_BASE_URL}/config`, values)
       .then((response) => {
         message.success('API added successfully');
         fetchApiGroups();
         setIsAddingApi(false);
         setIsEditingApi(false);
         setEditingApiData(null);
       })
       .catch((error) => {
         console.error('Error adding API:', error);
         message.error('Failed to add API');
       });
   }
 };

 useEffect(() => {
   const storedKeys = localStorage.getItem('orgApiKeys');
   if (storedKeys) {
     setOrgApiKeys(JSON.parse(storedKeys));
   }
 }, []);

 useEffect(() => {
   const storedOrgs = localStorage.getItem('orgs');
   if (storedOrgs) {
     setOrgs(JSON.parse(storedOrgs));
   }
 }, []);
 async function handleLogin(values) {
  setIsLoading(true);
  try {
    const headers = { 
      'Content-Type': 'application/json',    
      'env': selectedEnv,
      ...(selectedEnv === 'development' && devIp && { 'dev-ip': devIp.replace(/^https?:\/\//, '') }),
    };

    const response = await fetch(
      'https://specter-playground-proxy-server.azurewebsites.net/api/admin/v1/member/sign-in',
      {
        method: 'POST',
        headers,
        body: JSON.stringify({ email: values.email, password: values.password }),
      }
    );
    const data = await response.json();
    if (!response.ok) throw new Error(data.message || 'Login failed');
    const memberDetails = data.data.memberDetails;
    if (!memberDetails || !memberDetails.authToken)
      throw new Error('No authToken returned');

    setAuthToken(memberDetails.authToken);
    setMemberName(memberDetails.name);
    localStorage.setItem('isLoggedIn', 'true');
    localStorage.setItem('memberName', memberDetails.name);
    localStorage.setItem('authToken', memberDetails.authToken);
    
    // Store member ID if available
    if (memberDetails.id) {
      localStorage.setItem('memberId', memberDetails.id);
    }

    const orgArr = memberDetails.organisations || [];
    if (orgArr.length > 0) {
      setOrgs(orgArr);
      localStorage.setItem('orgs', JSON.stringify(orgArr));
      const keysMap = orgArr.reduce((acc, org) => {
        acc[org.id] = org.api_keys;
        return acc;
      }, {});
      setOrgApiKeys(keysMap);
      localStorage.setItem('orgApiKeys', JSON.stringify(keysMap));

      if (orgArr.length > 1) {
        setLoginStep(1);
        message.success('Login successful. Please select an org next.');
      } else if (orgArr.length === 1) {
        const onlyOrg = orgArr[0];
        setSelectedOrg(onlyOrg);
        localStorage.setItem('selectedOrgId', onlyOrg.id);
        finalizeLogin(onlyOrg);
      }
    } else {
      throw new Error('No organisations found for your account.');
    }
  } catch (error) {
    message.error(`Login failed: ${error.message}`);
  } finally {
    setIsLoading(false);
  }
}
// 5. Update handleGoogleLogin to store member ID:
const handleGoogleLogin = useGoogleLogin({
  onSuccess: async (tokenResponse) => {
    setIsLoading(true);
    try {
      const accessToken = tokenResponse.access_token;
      const userInfoResponse = await fetch(
        'https://www.googleapis.com/oauth2/v1/userinfo?alt=json',
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      const userInfo = await userInfoResponse.json();
      const { email, id: googleId } = userInfo;
      const headers = {
        'Content-Type': 'application/json',
        'env': selectedEnv,
        ...(selectedEnv === 'development' && devIp && { 'dev-ip': devIp.replace(/^https?:\/\//, '') }),
      };
      const payload = { email: email || '', password: null, googleId };
      const res = await fetch(
        'https://specter-playground-proxy-server.azurewebsites.net/api/admin/v1/member/sign-in',
        {
          method: 'POST',
          headers,
          body: JSON.stringify(payload),
        }
      );
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Google login failed');
      const memberDetails = data.data.memberDetails;
      if (!memberDetails?.authToken)
        throw new Error('No authToken returned from Google sign-in');

      setAuthToken(memberDetails.authToken);
      setMemberName(memberDetails.name);
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('memberName', memberDetails.name);
      localStorage.setItem('authToken', memberDetails.authToken);
      
      // Store member ID if available
      if (memberDetails.id) {
        localStorage.setItem('memberId', memberDetails.id);
      }

      const orgArr = memberDetails.organisations || [];
      if (orgArr.length > 0) {
        setOrgs(orgArr);
        localStorage.setItem('orgs', JSON.stringify(orgArr));
        const keysMap = orgArr.reduce((acc, org) => {
          acc[org.id] = org.api_keys;
          return acc;
        }, {});
        setOrgApiKeys(keysMap);
        localStorage.setItem('orgApiKeys', JSON.stringify(keysMap));

        if (orgArr.length > 1) {
          setLoginStep(1);
          message.success('Google sign-in success. Select org next!');
        } else if (orgArr.length === 1) {
          const onlyOrg = orgArr[0];
          setSelectedOrg(onlyOrg);
          localStorage.setItem('selectedOrgId', onlyOrg.id);
          finalizeLogin(onlyOrg);
        }
      } else {
        throw new Error('No organisations for this Google-linked account');
      }
    } catch (error) {
      message.error(`Google login failed: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  },
  onError: () => {
    message.error('Google login failed');
  },
});


// 3. Update ONLY the fetchSubscriptionStatus function (this goes through proxy):
const fetchSubscriptionStatus = async () => {
  if (!selectedOrg || !authToken) return;
  
  setLoadingSubscription(true);
  try {
    const response = await authAxios.post(
      '/api/admin/v1/organisation/get-subscription-status',
      { organisationId: selectedOrg.id }
    );
    
    if (response.data?.status === 'success') {
      setSubscriptionStatus(response.data.data);
    }
  } catch (error) {
    console.error('Failed to fetch subscription status:', error);
    // Auth service will handle 401 errors
  } finally {
    setLoadingSubscription(false);
  }
};

 function renderOrgSelectionStep() {
   return (
     <div>
       <Typography.Title level={5}>Select Organisation</Typography.Title>
       {orgs.map((org) => (
         <Card key={org.id} style={{ marginBottom: 8, cursor: 'pointer' }} onClick={() => {
           setSelectedOrg(org);
           localStorage.setItem('selectedOrgId', org.id);
           finalizeLogin(org);
         }}>
           {org.name}
         </Card>
       ))}
     </div>
   );
 }

 function finalizeLogin(org) {
   localStorage.setItem('selectedOrgId', org.id);
   setIsLoggedIn(true);
   setLoginModalVisible(false);
   message.success(`Using org: ${org.name}`);
 }


 useEffect(() => {
  if (selectedOrg && authToken) {
    fetchSubscriptionStatus();
  }
}, [selectedOrg, authToken]);

 const allFlattenedApis = useMemo(() => {
   return apiGroups.flatMap((groupObj) =>
     groupObj.apis.map((apiObj) => ({
       label: `${groupObj.group} / ${apiObj.name}`,
       value: `${groupObj.group}###${apiObj.name}`,
       groupName: groupObj.group,
       apiConfig: apiObj,
       tags: apiObj.tags || []
     }))
   );
 }, [apiGroups]);

 const capitalizeHeader = (header) =>
   header
     .split('-')
     .map(word => word.charAt(0).toUpperCase() + word.slice(1))
     .join('-');

 const handleSearchSelection = (value) => {
   const [groupName, apiName] = value.split('###');

   setSelectedGroup(groupName);

   const groupObj = apiGroups.find((g) => g.group === groupName);
   if (!groupObj) return;

   const foundApi = groupObj.apis.find((api) => api.name === apiName);
   if (!foundApi) return;

   setSelectedApi(foundApi);
 };

 useEffect(() => {
   if (selectedGroup && selectedApi) {
     const newValue = `${selectedGroup}###${selectedApi.name}`;
     setSearchBoxValue(newValue);
   }
 }, [selectedGroup, selectedApi]);

 // 2. Add these useEffects to store environment data (add after other useEffects):
useEffect(() => {
  localStorage.setItem('selectedEnv', selectedEnv);
}, [selectedEnv]);

useEffect(() => {
  if (devIp) {
    localStorage.setItem('devIp', devIp);
  }
}, [devIp]);


 const handleDocSwitch = (newApiName) => {
   let foundApi = null;
   for (const groupObj of apiGroups) {
     foundApi = groupObj.apis.find((api) => api.name === newApiName);
     if (foundApi) break;
   }
   if (!foundApi) {
     message.error('API not found for ' + newApiName);
     return;
   }
   setSelectedApi(foundApi);
 };

 const handleCategoryClick = (categoryName) => {
   const matchingGroup = apiGroups.find(group => 
     group.group.toLowerCase().includes(categoryName.toLowerCase()) ||
     categoryName.toLowerCase().includes(group.group.toLowerCase())
   );

   if (matchingGroup && matchingGroup.apis.length > 0) {
     setSelectedGroup(matchingGroup.group);
     
     const firstApi = matchingGroup.apis[0];
     
     setSelectedApi(firstApi);
     
     const searchValue = `${matchingGroup.group}###${firstApi.name}`;
     setSearchBoxValue(searchValue);
     
     setRequestParams({});
     setCodeSnippet('');
     setResponse(null);
   } else {
     const partialMatch = apiGroups.find(group => 
       group.group.toLowerCase().includes(categoryName.toLowerCase().split('/')[0])
     );
     
     if (partialMatch && partialMatch.apis.length > 0) {
       setSelectedGroup(partialMatch.group);
       const firstApi = partialMatch.apis[0];
       setSelectedApi(firstApi);
       
       const searchValue = `${partialMatch.group}###${firstApi.name}`;
       setSearchBoxValue(searchValue);
       
       setRequestParams({});
       setCodeSnippet('');
       setResponse(null);
     }
   }
 };





 return (
   <ThemeContext.Provider value={{ theme, currentTheme, switchTheme }}>
     <>
     {/* Global App Loader */}
     {isAppLoading && (
       <div style={{
         position: 'fixed',
         top: 0,
         left: 0,
         width: '100vw',
         height: '100vh',
         background: `linear-gradient(135deg, ${theme.background} 0%, ${theme.surface} 100%)`,
         display: 'flex',
         flexDirection: 'column',
         alignItems: 'center',
         justifyContent: 'center',
         zIndex: 10000,
         overflow: 'hidden'
       }}>
         {/* Subtle background gradient */}
         <div style={{
           position: 'absolute',
           width: '100%',
           height: '100%',
           background: `radial-gradient(circle at 50% 50%, ${theme.primary}08 0%, transparent 70%)`,
         }} />
         
         {/* Main loader content */}
         <div style={{
           position: 'relative',
           display: 'flex',
           flexDirection: 'column',
           alignItems: 'center',
           gap: '20px'
         }}>
           {/* Logo with subtle pulse */}
           <div style={{
             position: 'relative',
             animation: 'pulse 3s ease-in-out infinite'
           }}>
             <img
               src="/images/spec.png"
               alt="Specter"
               style={{ 
                 width: '80px', 
                 height: '80px',
                //  filter: `drop-shadow(0 0 15px ${theme.primary}40)`
               }}
             />
           </div>
           
           {/* Brand text */}
           <div style={{ textAlign: 'center' }}>
             <h1 style={{
               fontSize: '32px',
               fontWeight: '600',
               color: theme.text,
               margin: '0 0 4px 0',
               animation: 'slideUp 0.8s ease-out 0.3s both'
             }}>
               Sandbox
             </h1>
             <p style={{
               fontSize: '16px',
               color: theme.textSecondary,
               margin: 0,
               animation: 'slideUp 0.8s ease-out 0.5s both'
             }}>
               API Testing Environment
             </p>
           </div>
           
           {/* Progress bar */}
           <div style={{
             width: '200px',
             height: '3px',
             backgroundColor: `${theme.border}`,
             borderRadius: '2px',
             overflow: 'hidden',
             animation: 'slideUp 0.8s ease-out 0.7s both'
           }}>
             <div style={{
               width: '100%',
               height: '100%',
               background: `linear-gradient(90deg, ${theme.primary} 0%, ${theme.accent} 100%)`,
               borderRadius: '2px',
               animation: 'progressBar 2s ease-in-out infinite',
               transformOrigin: 'left'
             }} />
           </div>
           
           {/* Loading text */}
           <p style={{
             fontSize: '14px',
             color: theme.textSecondary,
             margin: 0,
             animation: 'slideUp 0.8s ease-out 0.9s both'
           }}>
             Initializing development workspace...
           </p>
         </div>
       </div>
     )}
     
     {!isAppLoading && (
       <>
     {/* {announcementVisible && (
  <Alert
    message={
      <span style={{ 
        color: '#ffffff',
        fontWeight: '500',
        fontSize: '14px',
        textShadow: '0 1px 2px rgba(0, 0, 0, 0.2)'
      }}>
        <ThunderboltOutlined style={{ 
          marginRight: 8,
          fontSize: '16px',
          animation: 'pulse 2s infinite'
        }} />
        Introducing the Specter AI Assistant Beta! Log in to your account to unlock our cutting-edge AI feature and supercharge your sandbox experience.
      </span>
    }
    type="info"
    banner
    closable
    closeIcon={
      <CloseOutlined 
        style={{ 
          color: '#ffffff',
          fontSize: '16px',
          fontWeight: 'bold'
        }} 
      />
    }
    onClose={() => setAnnouncementVisible(false)}
    style={{ 
      textAlign: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', // Purple gradient for both modes
      border: 'none',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
      padding: '12px 50px',
      position: 'relative',
      overflow: 'hidden'
    }}
    className="announcement-banner"
  />
)} */}
       <ConfigProvider theme={customTheme}>
         <Joyride
           steps={tourSteps}
           continuous
           locale={{ last: "Let's Start Exploring!" }}
           showSkipButton
           run={tourActive}
           styles={{
             options: {
               arrowColor: theme.surface,
               backgroundColor: theme.surface,
               overlayColor: currentTheme === 'dark' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.5)',
               primaryColor: theme.primary,
               textColor: theme.text,
               zIndex: 1000,
             },
             tooltip: {
               padding: '16px',
               borderRadius: '8px',
               boxShadow: currentTheme === 'dark' ? '0 4px 16px rgba(0, 0, 0, 0.5)' : '0 4px 16px rgba(0, 0, 0, 0.15)',
               position: 'relative',
               border: `1px solid ${theme.border}`,
             },
             tooltipContainer: {
               textAlign: 'left',
               fontSize: '14px',
               lineHeight: '1.5',
             },
             buttonNext: {
               backgroundColor: theme.primary,
               color: '#FFFFFF',
               fontSize: '14px',
               padding: '8px 16px',
               borderRadius: '4px',
               border: 'none',
               boxShadow: 'none',
             },
             buttonBack: {
               color: theme.textSecondary,
               fontSize: '14px',
               padding: '8px 16px',
             },
             buttonSkip: {
               color: theme.textSecondary,
               fontSize: '14px',
               padding: '8px 16px',
               borderRadius: '6px',
               border: `1px solid ${theme.border}`,
             },
             tooltipTitle: {
               fontSize: '16px',
               fontWeight: 'bold',
               marginBottom: '8px',
               color: theme.text,
             },
             tooltipContent: {
               paddingBottom: '12px',
               color: theme.textSecondary,
             },
             spotlight: {
               borderRadius: '8px',
               boxShadow: 'none',
             },
             arrow: {
               display: 'none',
             },
           }}
           callback={handleJoyrideCallback}
         />

         <Layout style={{ minHeight: '100vh', backgroundColor: theme.background }}>
           {/* Discord-style Left Sidebar */}
           <Sider 
  width={60}
  style={sidebarStyles}
  collapsed={true}
>
  <div style={{ 
    padding: '12px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    position: 'relative'
  }}>
    {/* Top section with logo and menu items */}
    <div style={{ flex: 1, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {/* Logo */}
      <div 
        style={{
          width: '48px',
          height: '48px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '8px',
          cursor: 'pointer',
          position: 'relative',
          transition: 'all 0.3s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
        }}
      >
        <img
          src="/images/spec.png"
          alt="Specter"
          style={{ width: '36px', height: '36px' }}
        />
      </div>
      
      <div style={{ 
        width: '32px', 
        height: '2px', 
        backgroundColor: theme.border,
        marginBottom: '8px'
      }} />

      {/* Menu Items */}
      {sidebarMenuItems.map((item) => {
        if (item.type === 'divider') {
          return (
            <div 
              key={item.key}
              style={{ 
                width: '32px', 
                height: '2px', 
                backgroundColor: theme.border,
                margin: '8px 0'
              }} 
            />
          );
        }
        
        return (
          <Tooltip 
            key={item.key} 
            placement="right" 
            title={item.tooltip}
          >
            <div
              onClick={item.onClick}
              style={activeSection === item.key ? activeSidebarItemStyles : sidebarItemStyles}
              onMouseEnter={(e) => {
                if (activeSection !== item.key) {
                  e.currentTarget.style.backgroundColor = theme.surfaceLight;
                  e.currentTarget.style.borderRadius = '16px';
                  e.currentTarget.style.borderColor = theme.primary;
                }
              }}
              onMouseLeave={(e) => {
                if (activeSection !== item.key) {
                  e.currentTarget.style.backgroundColor = theme.surfaceLight;
                  e.currentTarget.style.borderRadius = '50%';
                  e.currentTarget.style.borderColor = theme.border;
                }
              }}
            >
              {item.icon}
            </div>
          </Tooltip>
        );
      })}
    </div>
    
    {/* Bottom section with plan name and help */}
    <div style={{
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: theme.surface,
    }}>
      {/* Plan name above divider */}
      <div style={{
        padding: '8px 12px',
        textAlign: 'center',
      }}>
        <span style={{ 
          fontSize: '11px', 
          fontWeight: 'bold',
          color: theme.text,
          whiteSpace: 'nowrap'
        }}>
          {!isLoggedIn ? 'Guest' : (
            loadingSubscription ? 'Loading...' : 
            subscriptionStatus ? subscriptionStatus.name.replace('Specter-', '').replace(' Plan', '') : 
            ''
          )}
        </span>
      </div>
      
      {/* Divider */}
      <div style={{
        width: '100%',
        height: '1px',
        backgroundColor: theme.border,
      }} />
      
      {/* Help icon below divider */}
      <div style={{
        padding: '12px',
        display: 'flex',
        justifyContent: 'center',
      }}>
        <Dropdown
          overlay={menu}
          placement="topRight"
          trigger={['click']}
        >
          <div style={{
            width: '32px',
            height: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            borderRadius: '8px',
            transition: 'all 0.2s ease',
            backgroundColor: 'transparent',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = theme.surfaceLight;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
          }}>
            <QuestionCircleOutlined style={{ fontSize: '16px', color: theme.textSecondary }} />
          </div>
        </Dropdown>
      </div>
    </div>
  </div>
</Sider>
           <Layout style={{ marginLeft: 72, backgroundColor: theme.background }}>
             <Header
               style={{
                 height: '50px',
                 backgroundColor: theme.surface,
                 padding: '0 20px',
                 display: 'flex',
                 justifyContent: 'space-between',
                 alignItems: 'center',
                 boxShadow: currentTheme === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.1)',
                 borderBottom: `1px solid ${theme.border}`,
               }}
             >
   <Title level={4} style={{ color: theme.text, margin: 0 }}>
  {isRecipeMode ? 'Recipe Manager' : isDevMode ? 'API Manager' : 'Sandbox'}
</Title>
               
               <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                 {/* Theme Switcher */}
                 <Space>
                   <SunOutlined style={{ color: currentTheme === 'light' ? theme.accent : theme.textSecondary }} />
                   <Switch
                     checked={currentTheme === 'dark'}
                     onChange={(checked) => switchTheme(checked ? 'dark' : 'light')}
                     style={{
                       backgroundColor: currentTheme === 'dark' ? theme.primary : undefined
                     }}
                   />
                   <MoonOutlined style={{ color: currentTheme === 'dark' ? theme.primary : theme.textSecondary }} />
                 </Space>

                 {!isProductionMode && (
                   <Select
                     defaultValue="console"
                     style={{ width: 150 }}
                     onChange={(value) => setSelectedEnv(value)}
                   >
                     <Option value="development">Development</Option>
                     <Option value="staging">Staging</Option>
                     <Option value="demo">Demo</Option>
                     <Option value="console">Console</Option>
                   </Select>
                 )}

                 {/* <Dropdown overlay={menu} placement="bottomRight" arrow>
                   <Button 
                     type="text" 
                     icon={<MenuOutlined style={{ fontSize: '20px', color: theme.text }} />}
                     style={{ color: theme.text }}
                   />
                 </Dropdown> */}

                 <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                   {!isLoggedIn ? (
                     <Button 
                       type="primary" 
                       onClick={() => setLoginModalVisible(true)}
                       style={{
                         background: `linear-gradient(135deg, ${theme.primary} 0%, ${theme.primaryDark} 100%)`,
                         border: 'none',
                         boxShadow: `0 2px 8px ${theme.primary}40`,
                       }}
                     >
                       Log in
                     </Button>
                   ) : (
                     <UserDropdown
                       memberName={memberName}
                       currentOrg={selectedOrg}
                       onSwitchOrg={() => {
                         setLoginModalVisible(true);
                         setLoginStep(1);
                       }}
                       onLogout={handleLogout}
                     />
                   )}
                 </div>
               </div>
             </Header>

             <Modal
               title="Log in with your Specter Account"
               visible={loginModalVisible}
               onCancel={() => setLoginModalVisible(false)}
               footer={null}
               style={{ top: 20 }}
             >
               {loginStep === 0 && (
                 <Form layout="vertical" onFinish={handleLogin}>
                   <Form.Item
                     name="email"
                     label="Email"
                     rules={[{ required: true, message: 'Please enter your email' }]}
                   >
                     <Input placeholder="Enter your email" />
                   </Form.Item>
                   <Form.Item
                     name="password"
                     label="Password"
                     rules={[{ required: true, message: 'Please enter your password' }]}
                   >
                     <Input.Password placeholder="Enter your password" />
                   </Form.Item>
                   <Form.Item>
                     <Button
                       type="primary"
                       htmlType="submit"
                       loading={isLoading}
                       style={{ width: '100%' }}
                     >
                       Log in
                     </Button>
                   </Form.Item>

                   <Divider>or</Divider>
                   <Button
                     type="default"
                     onClick={() => handleGoogleLogin()}
                     icon={
                       <img
                         src={`${process.env.PUBLIC_URL}/images/google2.svg`}
                         alt="Google"
                         style={{
                           width: '20px',
                           height: '20px',
                           marginRight: '4px'
                         }}
                       />
                     }
                     style={{ width: '100%' }}
                   >
                     Sign in with Google
                   </Button>
                 </Form>
               )}

               {loginStep === 1 && renderOrgSelectionStep()}
             </Modal>

             {(!isDevMode && !isRecipeMode && activeSection === 'sandbox') && (
               <Card
                 bordered={false}
                 style={{
                   backgroundColor: theme.surface,
                   padding: '16px 20px',
                   borderRadius: '0',
                   marginBottom: '20px',
                   borderBottom: `1px solid ${theme.border}`,
                 }}
               >
                 <Row gutter={[16, 0]} align="middle">
                   <Col xs={24} lg={6}>
                     <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                       <CodeOutlined style={{ fontSize: '22px', color: theme.primary, marginRight: '8px' }} />
                       <Title level={4} style={{ margin: 0, color: theme.text }}>
                         Build Next-Gen Gaming Experiences
                       </Title>
                     </div>
                     <Paragraph style={{ fontSize: '13px', color: theme.textSecondary, marginBottom: '0', lineHeight: '1.5' }}>
                       Explore our suite of powerful APIs designed to create immersive, scalable gaming worlds that keep players engaged!
                     </Paragraph>
                   </Col>
                   
                   <Col xs={24} lg={18}>
                     <Row gutter={[8, 8]}>
                     {categoryMappings.map((category, index) => (
  <Col key={`${currentTheme}-${index}`} xs={12} sm={8} md={6} lg={4}>
    <div 
      style={{ 
        padding: '8px 10px', 
        background: theme.surfaceLight, 
        borderRadius: '6px', 
        cursor: 'pointer',
        transition: 'all 0.2s',
        boxShadow: currentTheme === 'dark' ? '0 1px 2px rgba(0,0,0,0.3)' : '0 1px 2px rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        height: '36px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        border: `1px solid ${theme.border}`,
        borderLeft: `3px solid ${category.color}`, // Always visible
      }}
      onClick={() => handleCategoryClick(category.groupName || category.name)}
      onMouseOver={(e) => {
        const currentCategory = categoryMappings[index];
        e.currentTarget.style.boxShadow = currentTheme === 'dark' ? `0 4px 8px rgba(0,0,0,0.5)` : `0 4px 8px rgba(0,0,0,0.15)`;
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.borderLeft = `4px solid ${currentCategory.color}`; // Thicker on hover
        e.currentTarget.style.backgroundColor = theme.surface;
      }}
      onMouseOut={(e) => {
        const currentCategory = categoryMappings[index];
        e.currentTarget.style.boxShadow = currentTheme === 'dark' ? '0 1px 2px rgba(0,0,0,0.3)' : '0 1px 2px rgba(0,0,0,0.1)';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.borderLeft = `3px solid ${currentCategory.color}`; // Back to normal
        e.currentTarget.style.backgroundColor = theme.surfaceLight;
      }}
    >
      <Text style={{ 
        fontSize: '12px', 
        whiteSpace: 'nowrap', 
        overflow: 'hidden', 
        textOverflow: 'ellipsis',
        fontWeight: '500',
        color: theme.text
      }}>
        {category.name}
      </Text>
    </div>
  </Col>
))}
                     </Row>
                   </Col>
                 </Row>
               </Card>
             )}

<Content style={{ padding: '20px 40px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
  {isRecipeMode ? (
  <>
    {isRunningRecipe ? (
      <RecipeRunner
        recipe={runningRecipeData}
        onClose={handleCloseRunner}
        selectedEnv={selectedEnv}
        devIp={devIp}
      />
    ) : isAddingRecipe || isEditingRecipe ? (
      // This should never happen in sandbox mode
      <div style={{ padding: '20px' }}>
        <Alert
          message="Recipe Management"
          description="Please use API Manager to create or edit recipes"
          type="info"
          showIcon
        />
        <Button onClick={() => setIsRecipeMode(false)} style={{ marginTop: '16px' }}>
          Back to Sandbox
        </Button>
      </div>
    ) : (
      <RecipeList
        onAddRecipe={handleAddRecipe}
        onEditRecipe={handleEditRecipe}
        onRunRecipe={handleRunRecipe}
      />
    )}
  </>
) : isDevMode ? (
          
              <ApiManager
                onCancel={() => {
                  setIsDevMode(false);
                  setActiveSection('sandbox');
                  resetStates();
                }}
                onApiChange={fetchApiGroups}
              />
            ) : activeSection === 'edge-functions' ? (
              !isLoggedIn || !selectedOrg ? (
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '60px 20px',
                  textAlign: 'center',
                }}>
                  <div style={{
                    fontSize: '48px',
                    marginBottom: '16px',
                  }}>
                    🔐
                  </div>
                  <h3 style={{ color: theme.text, marginBottom: '8px' }}>
                    Sign in Required
                  </h3>
                  <p style={{ color: theme.textSecondary, maxWidth: '400px' }}>
                    Please sign in and select an organisation to access Edge Functions.
                  </p>
                </div>
              ) : (
              <EdgeFunctionSandbox
                // Environment props
                selectedEnv={edgeFunctionEnv}
                onSelectEnv={handleEdgeFunctionEnvSelect}
                orgApiKeys={selectedOrg ? orgApiKeys[selectedOrg.id] : {}}
                // Project props
                projects={edgeFunctionProjects}
                selectedProject={selectedEdgeFunctionProject}
                onSelectProject={handleEdgeFunctionProjectSelect}
                isLoadingProjects={edgeFunctionProjectsLoading}
                // Edge function props
                edgeFunctions={edgeFunctions}
                selectedEdgeFunction={selectedEdgeFunction}
                onSelectFunction={setSelectedEdgeFunction}
                edgeFunctionJwt={edgeFunctionJwt}
                playerToken={bearerToken}
                onPlayerTokenChange={setBearerToken}
                onRunFunction={handleRunEdgeFunction}
                response={edgeFunctionResponse}
                isLoading={edgeFunctionLoading}
                isFetchingFunctions={edgeFunctionsLoading}
                onRefreshFunctions={() => {
                  if (selectedEdgeFunctionProject?.id) {
                    fetchEdgeFunctions(selectedEdgeFunctionProject.id);
                  }
                }}
              />
              )
            ) : (
              <>
                   {selectedEnv === 'development' && (
                     <Card
                       title="Development Server URL"
                       bordered={false}
                       style={{ 
                         marginBottom: '20px',
                         backgroundColor: theme.surface,
                         border: `1px solid ${theme.border}`,
                       }}
                       extra={
                         <Switch
                           checked={showDevServerCredentials}
                           onChange={() => setShowDevServerCredentials(!showDevServerCredentials)}
                           checkedChildren="Hide"
                           unCheckedChildren="Show"
                         />
                       }
                     >
                       {showDevServerCredentials && (
                         <Form layout="vertical">
                           <Form.Item label={<span style={{ color: theme.text }}>Enter your Development Server URL</span>}>
                             <Input
                               placeholder="Enter Development Server URL"
                               value={devIp}
                               onChange={(e) => setDevIp(e.target.value)}
                               style={{
                                 backgroundColor: theme.surfaceLight,
                                 borderColor: theme.border,
                                 color: theme.text,
                               }}
                             />
                           </Form.Item>
                           <Button type="primary" onClick={handleSaveDevIp}>
                             Save
                           </Button>
                         </Form>
                       )}
                     </Card>
                   )}
                   
                   <div style={{
                     background: theme.surface,
                     border: `1px solid ${theme.border}`,
                     borderRadius: '8px',
                     padding: '12px 16px',
                     display: 'flex',
                     alignItems: 'center',
                     justifyContent: 'space-between',
                     boxShadow: currentTheme === 'dark' ? '0 2px 4px rgba(0, 0, 0, 0.3)' : '0 2px 4px rgba(0, 0, 0, 0.1)',
                     position: 'relative'
                   }}>
                     <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                       <div style={{
                         width: '32px',
                         height: '32px',
                         backgroundColor: theme.primary,
                         borderRadius: '6px',
                         display: 'flex',
                         alignItems: 'center',
                         justifyContent: 'center',
                         boxShadow: `0 0 8px ${theme.primary}40`,
                       }}>
                         <ApiOutlined style={{ color: '#fff', fontSize: '16px' }} />
                       </div>
                       <div>
                         <Text style={{ fontSize: '11px', color: theme.textSecondary, display: 'block', marginBottom: '2px' }}>
                           API Base URL
                         </Text>
                         <Text style={{ 
                           fontSize: '14px', 
                           fontWeight: '600',
                           color: theme.text,
                           fontFamily: 'Monaco, Consolas, "Courier New", monospace',
                           letterSpacing: '0.5px'
                         }}>
                           https://api.specterapp.xyz
                         </Text>
                       </div>
                     </div>
                     
                     <Button
                       type="text"
                       icon={<CopyOutlined />}
                       onClick={() => handleCopyToClipboard('https://api.specterapp.xyz')}
                       style={{ 
                         color: theme.primary,
                         backgroundColor: `${theme.primary}15`,
                         border: `1px solid ${theme.primary}30`,
                         borderRadius: '6px',
                         padding: '6px 12px',
                         transition: 'all 0.2s ease'
                       }}
                       onMouseEnter={(e) => {
                         e.currentTarget.style.backgroundColor = `${theme.primary}25`;
                       }}
                       onMouseLeave={(e) => {
                         e.currentTarget.style.backgroundColor = `${theme.primary}15`;
                       }}
                     >
                       Copy
                     </Button>
                   </div>
                   
                   <Card
                     className="api-credentials"
                     title={<span style={{ color: theme.text }}>API Credentials</span>}
                     bordered={false}
                     style={{ 
                       marginBottom: '20px',
                       backgroundColor: theme.surface,
                       border: `1px solid ${theme.border}`,
                     }}
                     extra={
                       <Switch
                         checked={showCredentials}
                         onChange={() => setShowCredentials(!showCredentials)}
                         checkedChildren="Hide"
                         unCheckedChildren="Show"
                       />
                     }
                   >
                     {showCredentials && (
                       <>
                         {hasUnsavedChanges && (
                           <div style={{
                             backgroundColor: `${theme.accent}20`,
                             border: `1px solid ${theme.accent}50`,
                             borderRadius: '4px',
                             padding: '8px 12px',
                             marginBottom: '16px',
                             fontSize: '12px',
                             color: theme.accent,
                             display: 'flex',
                             alignItems: 'center',
                             gap: '8px'
                           }}>
                             <InfoCircleOutlined />
                             <span>You have unsaved changes. Click "Save Credentials" to apply them.</span>
                           </div>
                         )}
                         
                         <p style={{ color: theme.textSecondary, marginTop: '-8px', marginBottom: '10px' }}>
                           Enter your API key for your application environment. For player-related APIs, you'll also need a Bearer Token which you can obtain by logging in or signing up a player.
                         </p>
                         
                         <Form layout="vertical">
                           <Row gutter={16}>
                             <Col span={12}>
                               <Form.Item
                                 label={
                                   <span style={{ color: theme.text }}>
                                     API Key&nbsp;
                                     <Tooltip
                                       title="Used to authenticate API requests from this app. Keep it secure."
                                       placement="right"
                                     >
                                       <InfoCircleOutlined style={{ color: theme.textSecondary }} />
                                     </Tooltip>
                                     &nbsp;
                                     <span
                                       onClick={() => {
                                         if (!isLoggedIn) {
                                           message.info('Please log in to select your API key.');
                                         } else {
                                           setShowApiKeySelector(true);
                                         }
                                       }}
                                       style={{ color: theme.primary, cursor: 'pointer', textDecoration: 'underline' }}
                                     >
                                       Select your API key
                                     </span>
                                   </span>
                                 }
                               >
                                 <Input
                                   placeholder="Enter API Key"
                                   className="api-key-input"
                                   value={apiKey}
                                   onChange={(e) => setApiKey(e.target.value)}
                                   style={{
                                     backgroundColor: currentTheme === 'dark' ? '#262626' : theme.surfaceLight,
                                     borderColor: hasUnsavedChanges && apiKey !== (localStorage.getItem('apiKey') || '') 
                                       ? theme.accent : theme.border,
                                     color: theme.text,
                                   }}
                                   suffix={
                                     <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                       {hasUnsavedChanges && apiKey !== (localStorage.getItem('apiKey') || '') && (
                                         <div style={{
                                           width: '6px',
                                           height: '6px',
                                           borderRadius: '50%',
                                           backgroundColor: theme.accent
                                         }} />
                                       )}
                                       <CopyOutlined 
                                         onClick={() => handleCopyToClipboard(apiKey)}
                                         style={{ color: theme.textSecondary, cursor: 'pointer' }}
                                       />
                                     </div>
                                   }
                                 />
                               </Form.Item>
                             </Col>

                             <Col span={12}>
                               <Form.Item
                                 label={
                                   <span style={{ color: theme.text }}>
                                     Bearer Token&nbsp;
                                     <Tooltip
                                       title="Grants access for the player's session. Keep it secure."
                                       placement="right"
                                     >
                                       <InfoCircleOutlined style={{ color: theme.textSecondary }} />
                                     </Tooltip>
                                   </span>
                                 }
                               >
                                 <Input
                                   placeholder="Enter Bearer Token"
                                   value={bearerToken}
                                   onChange={(e) => setBearerToken(e.target.value)}
                                   style={{
                                     backgroundColor: theme.surfaceLight,
                                     borderColor: hasUnsavedChanges && bearerToken !== (localStorage.getItem('bearerToken') || '') 
                                       ? theme.accent : theme.border,
                                     color: theme.text,
                                   }}
                                   suffix={
                                     <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                       {hasUnsavedChanges && bearerToken !== (localStorage.getItem('bearerToken') || '') && (
                                         <div style={{
                                           width: '6px',
                                           height: '6px',
                                           borderRadius: '50%',
                                           backgroundColor: theme.accent
                                         }} />
                                       )}
                                       <CopyOutlined 
                                         onClick={() => handleCopyToClipboard(bearerToken)}
                                         style={{ color: theme.textSecondary, cursor: 'pointer' }}
                                       />
                                     </div>
                                   }
                                 />
                               </Form.Item>
                             </Col>
                           </Row>

                           <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                             <Button 
                               type="primary" 
                               onClick={handleSaveCredentials}
                               loading={saveStatus === 'saving'}
                               disabled={!hasUnsavedChanges}
                               style={{
                                 background: hasUnsavedChanges 
                                   ? theme.primary
                                   : theme.surfaceLight,
                                 borderColor: hasUnsavedChanges 
                                   ? theme.primary
                                   : theme.border,
                                 opacity: !hasUnsavedChanges ? 0.5 : 1,
                                 boxShadow: hasUnsavedChanges ? `0 2px 8px ${theme.primary}40` : 'none',
                               }}
                             >
                               {saveStatus === 'saving' ? 'Saving...' : 'Save Credentials'}
                             </Button>
                             
                             {saveStatus === 'saved' && !hasUnsavedChanges && (
                               <Text style={{ color: theme.success, fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                 <CheckOutlined /> Saved
                               </Text>
                             )}
                             
                             {hasUnsavedChanges && (
                               <Text style={{ color: theme.accent, fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                 <InfoCircleOutlined /> Unsaved changes
                               </Text>
                             )}
                           </div>
                         </Form>
                       </>
                     )}
                   </Card>

                   <div style={{ display: 'flex', gap: '20px' }}>
                     <div style={{ flex: 1 }}>
                       <Card 
                         title={<span style={{ color: theme.text }}>API Selection</span>}
                         bordered={false} 
                         style={{ 
                           marginBottom: '20px',
                           backgroundColor: theme.surface,
                           border: `1px solid ${theme.border}`,
                         }}
                       >
                         <p style={{ color: theme.textSecondary, marginTop: '-8px', marginBottom: '10px' }}>
                           Select an API category and a specific API endpoint to interact with.
                         </p>
                         <Select
                           showSearch
                           style={{ width: '100%' }}
                           placeholder="Search by API name or keywords..."
                           onChange={handleSearchSelection} 
                           filterOption={(inputValue, option) => {
                             if (!option) return false;

                             const label = option.label || '';
                             const tags  = option.tags  || [];

                             const searchText = inputValue.toLowerCase();
                             const labelMatch = label.toLowerCase().includes(searchText);
                             const tagMatch   = tags.some((tag) => tag.toLowerCase().includes(searchText));

                             return labelMatch || tagMatch;
                           }}
                         >
                           {allFlattenedApis.map((item) => (
                             <Select.Option
                               key={item.value}
                               label={item.label}
                               tags={item.tags}
                               value={item.value}
                             >
                               {item.label}
                             </Select.Option>
                           ))}
                         </Select>

                         <Select
                           className="api-group-select"
                           placeholder="Select API Category"
                           style={{ width: '100%', marginTop: '10px' }}
                           onChange={handleGroupChange}
                           value={selectedGroup}
                         >
                           {groupOptions.map((group) => (
                             <Option key={group.name} value={group.name}>
                               <Tooltip title={group.description} placement="right">
                                 <span>{group.name}</span>
                               </Tooltip>
                             </Option>
                           ))}
                         </Select>

                         <Select
                           className="api-select"
                           placeholder="Select API"
                           style={{ width: '100%', marginTop: '10px' }}
                           onChange={handleApiChange}
                           disabled={!selectedGroup}
                           value={selectedApi ? selectedApi.name : undefined}
                         >
                           {selectedGroup &&
                             apiGroups
                               .find((group) => group.group === selectedGroup)
                               ?.apis?.map((api) => (
                                 <Option key={api.name} value={api.name}>
                                   {api.name}
                                 </Option>
                               ))}
                         </Select>

                         {selectedApi && selectedApi.description && (
                           <div
                             style={{
                               marginTop: '15px',
                               backgroundColor: theme.surfaceLight,
                               padding: '10px',
                               borderRadius: '6px',
                               border: `1px solid ${theme.border}`,
                             }}
                           >
                             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                               <Text strong style={{ color: theme.text }}>API Details</Text>
                               <Tag 
                                 color={selectedApi.method === 'GET' ? 'green' : selectedApi.method === 'POST' ? 'blue' : selectedApi.method === 'PUT' ? 'orange' : 'red'}
                                 style={{ margin: 0 }}
                               >
                                 {selectedApi.method} {selectedApi.route}
                               </Tag>
                             </div>
                             <Paragraph style={{ fontSize: '14px', color: theme.textSecondary, marginBottom: '0' }}>
                               {selectedApi.description}
                             </Paragraph>
        
                             {selectedApi.tags && selectedApi.tags.length > 0 && (
                               <div style={{ marginTop: '10px' }}>
                                 {selectedApi.tags.map((tag, index) => {
                                   const color = getTagColor(index);
                                   return (
                                     <Tag 
                                       key={tag} 
                                       style={{ 
                                         marginBottom: '4px',
                                         backgroundColor: `${color}20`,
                                         borderColor: color,
                                         color: color,
                                       }}
                                     >
                                       {tag}
                                     </Tag>
                                   );
                                 })}
                               </div>
                             )}

                             {selectedApi.requiredHeaders && selectedApi.requiredHeaders.length > 0 && (
                               <div style={{ marginTop: '10px' }}>
                                 <Text strong style={{ color: theme.text }}>Required Headers: </Text>
                                 {selectedApi.requiredHeaders.map((hdr) => (
                                   <Tooltip key={hdr.name} title={hdr.description || 'No description'}>
                                     <Tag 
                                       color="volcano" 
                                       style={{ 
                                         marginBottom: '4px',
                                         backgroundColor: `${theme.error}20`,
                                         borderColor: theme.error,
                                         color: theme.error,
                                       }}
                                     >
                                       {capitalizeHeader(hdr.name)}
                                     </Tag>
                                   </Tooltip>
                                 ))}
                               </div>
                             )}

                             <Divider style={{ margin: '20px 0', borderColor: theme.border }} />

                             <Row justify="end" gutter={16}>
                               {selectedApi.longDescription && (
                                 <Col>
                                   <Button
                                     type="default"
                                     onClick={() => setDocsDrawerVisible(true)}
                                     style={{ borderRadius: '6px' }}
                                   >
                                     API Reference
                                   </Button>
                                 </Col>
                               )}
                               {selectedApi.examples && selectedApi.examples.length > 0 && (
                                 <Col>
                                   <Button
                                     type="default"
                                     onClick={() => setExamplesDrawerVisible(true)}
                                     style={{ borderRadius: '6px' }}
                                   >
                                     Usage Examples
                                   </Button>
                                 </Col>
                               )}
                             </Row>
                           </div>
                         )}
                       </Card>

                       <Drawer
                         placement="right"
                         visible={docsDrawerVisible}
                         onClose={() => {
                           setDocsDrawerVisible(false);
                           setApiRefDrawerFullscreen(false);
                         }}
                         width={apiRefDrawerFullscreen ? '100%' : 800}
                         style={apiRefDrawerFullscreen ? { top: 0, margin: 0, padding: 0, zIndex: 9999 } : {}}
                         bodyStyle={{
                           backgroundColor: theme.surface,
                           padding: apiRefDrawerFullscreen ? '16px 24px' : '12px'
                         }}
                         destroyOnClose
                         maskClosable
                         title={
                           <Row justify="space-between" align="middle" style={{ width: '100%' }}>
                             <Col>
                               <Typography.Title level={4} style={{ margin: 0, color: theme.text }}>
                                 API Reference
                               </Typography.Title>
                             </Col>

                             <Col>
                               <Space>
                                 <Select
                                   showSearch
                                   style={{ width: 220 }}
                                   placeholder="Switch API Docs"
                                   value={selectedApi?.name}
                                   onChange={handleDocSwitch}
                                   filterOption={(inputValue, option) => {
                                     if (!option) return false;
                                     const label = option.children?.toLowerCase() || "";
                                     return label.includes(inputValue.toLowerCase());
                                   }}
                                 >
                                   {apiGroups.flatMap((g) =>
                                     g.apis
                                       .filter((api) => api.longDescription && api.longDescription.trim() !== "")
                                       .map((api) => (
                                         <Select.Option key={`${g.group}###${api.name}`} value={api.name}>
                                           {g.group} / {api.name}
                                         </Select.Option>
                                       ))
                                   )}
                                 </Select>

                                 <Button
                                   type="text"
                                   icon={apiRefDrawerFullscreen ? <CompressOutlined /> : <ExpandOutlined />}
                                   onClick={() => setApiRefDrawerFullscreen((prev) => !prev)}
                                 />
                               </Space>
                             </Col>
                           </Row>
                         }
                       >
                         
                         {selectedApi && (
                           <Card
                             bordered={false}
                             style={{ marginBottom: '20px' }}
                             bodyStyle={{ padding: '10px' }}
                           >
                             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                               <div>
                                 <Typography.Title level={5} style={{ margin: 0, color: theme.text }}>
                                   {selectedApi.name}
                                 </Typography.Title>
                                 <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                   <Typography.Text type="secondary" style={{ fontSize: '14px' }}>
                                     {SPECTER_ENV_URL + selectedApi.route}
                                   </Typography.Text>

                                   <RouteCopyButton route={SPECTER_ENV_URL + selectedApi.route} />
                                 </div>
                               </div>
                               <div>
                                 <Tag
                                   style={{ fontSize: '14px', padding: '4px 8px' }}
                                   color={
                                     selectedApi.method === 'GET'
                                       ? 'green'
                                       : selectedApi.method === 'POST'
                                       ? 'blue'
                                       : selectedApi.method === 'PUT'
                                       ? 'orange'
                                       : 'red'
                                   }
                                 >
                                   {selectedApi.method}
                                 </Tag>
                               </div>
                             </div>
                           </Card>
                         )}
                         
                         {selectedApi?.examples && selectedApi.examples.length > 0 && (
                           <div 
                             style={{
                               display: 'flex', 
                               justifyContent: 'flex-end', 
                               marginBottom: '16px'
                             }}
                           >
                             <Button
                               type="dashed"
                               shape="round"
                               icon={<ArrowRightOutlined />}
                               onClick={() => {
                                 setDocsDrawerVisible(false);
                                 setExamplesDrawerVisible(true);
                               }}
                             >
                               View Usage Examples
                             </Button>
                           </div>
                         )}

                         {selectedApi?.longDescription ? (
                           <div
                             className={`documentation-content ${currentTheme === 'dark' ? 'dark-theme' : ''}`}
                             style={{ overflowY: "auto", maxHeight: "calc(100vh - 130px)" }}
                             dangerouslySetInnerHTML={{ __html: selectedApi.longDescription }}
                           />
                         ) : (
                           <Typography.Text style={{ color: theme.textSecondary }}>
                             No documentation available.
                           </Typography.Text>
                         )}
                       </Drawer>

                       <Drawer
                         placement="right"
                         visible={examplesDrawerVisible}
                         onClose={() => {
                           setExamplesDrawerVisible(false);
                           setExamplesDrawerFullscreen(false);
                         }}
                         width={examplesDrawerFullscreen ? '100%' : 800}
                         style={
                           examplesDrawerFullscreen
                             ? {
                                 top: 0,
                                 margin: 0,
                                 padding: 0,
                                 zIndex: 9999,
                               }
                             : {}
                         }
                         bodyStyle={{
                           backgroundColor: theme.surface,
                           padding: examplesDrawerFullscreen ? '16px 24px' : '12px',
                         }}
                         destroyOnClose
                         maskClosable
                         title={
                           <Row justify="space-between" align="middle" style={{ width: '100%' }}>
                             <Col>
                               <Typography.Title level={4} style={{ margin: 0, color: theme.text }}>
                                 Usage Examples
                               </Typography.Title>
                             </Col>
                             <Col>
                               <Button
                                 type="text"
                                 icon={examplesDrawerFullscreen ? <CompressOutlined /> : <ExpandOutlined />}
                                 onClick={() => setExamplesDrawerFullscreen((prev) => !prev)}
                               />
                             </Col>
                           </Row>
                         }
                       >
                         <ExampleDrawerContent 
                           examples={selectedApi?.examples}
                           selectedApi={selectedApi} 
                           onClose={() => setExamplesDrawerVisible(false)}
                           setDocsDrawerVisible={setDocsDrawerVisible}
                           setExamplesDrawerVisible={setExamplesDrawerVisible}
                         />
                       </Drawer>
                       
                       {selectedApi && (
                         <div style={{
                           background: theme.surfaceLight,
                           border: `1px solid ${theme.border}`,
                           borderRadius: '6px',
                           padding: '8px 16px',
                           marginBottom: '16px',
                           fontSize: '11px',
                           color: theme.text,
                           display: 'flex',
                           alignItems: 'center',
                           justifyContent: 'space-between',
                           whiteSpace: 'nowrap'
                         }}>
                           <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                             <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                               <Text style={{ color: theme.error, fontWeight: 'bold' }}>*</Text> Required
                             </span>
                             <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                               <span style={{ 
                                 color: theme.accent, 
                                 fontSize: '8px',
                                 fontWeight: 'bold',
                                 backgroundColor: `${theme.accent}20`,
                                 padding: '1px 3px',
                                 borderRadius: '2px'
                               }}>(either/or)</span> Alternative
                             </span>
                             <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                               <span style={{ 
                                 color: '#C678DD', 
                                 fontSize: '8px',
                                 fontWeight: 'bold',
                                 backgroundColor: '#C678DD20',
                                 padding: '1px 3px',
                                 borderRadius: '2px'
                               }}>(conditional)</span> Conditional
                             </span>
                             <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                               <span style={{ 
                                 color: theme.error, 
                                 fontSize: '8px',
                                 fontWeight: 'bold',
                                 backgroundColor: `${theme.error}20`,
                                 padding: '1px 3px',
                                 borderRadius: '2px'
                               }}>(exclusive)</span> Exclusive
                             </span>
                             <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                               <InfoCircleOutlined style={{ color: theme.primary, fontSize: '10px' }} /> Hover Info
                             </span>
                           </div>
                           
                           <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                             <Button 
                               type="link" 
                               size="small"
                               onClick={() => setFieldGuideVisible(true)}
                               style={{ 
                                 fontSize: '9px', 
                                 color: theme.primary,
                                 padding: '0 4px',
                                 height: 'auto',
                                 textDecoration: 'underline'
                               }}
                             >
                               Learn More
                             </Button>
                             <Text style={{ 
                               fontSize: '9px', 
                               color: theme.textSecondary,
                               fontWeight: '500',
                               textTransform: 'uppercase',
                               letterSpacing: '0.5px'
                             }}>
                               Field Indicators
                             </Text>
                           </div>
                         </div>
                       )}

                       <Modal
                         title="Field Indicators Guide"
                         visible={fieldGuideVisible}
                         onCancel={() => setFieldGuideVisible(false)}
                         footer={[
                           <Button key="close" type="primary" onClick={() => setFieldGuideVisible(false)}>
                             Got it!
                           </Button>
                         ]}
                         width={700}
                       >
                         <div style={{ fontSize: '14px' }}>
                           <Row gutter={[0, 20]}>
                             <Col span={24}>
                               <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                 <Text style={{ color: theme.error, fontWeight: 'bold', fontSize: '18px' }}>*</Text>
                                 <div>
                                   <Text strong style={{ fontSize: '16px', display: 'block', marginBottom: '4px' }}>
                                     Required Field
                                   </Text>
                                   <Text style={{ color: theme.textSecondary, lineHeight: '1.5' }}>
                                     This field is always required and must be provided for the API call to work. 
                                     The request will fail if this field is missing or empty.
                                   </Text>
                                 </div>
                               </div>
                             </Col>

                             <Col span={24}>
                               <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                 <span style={{ 
                                   color: theme.accent, 
                                   fontSize: '12px',
                                   fontWeight: 'bold',
                                   backgroundColor: `${theme.accent}20`,
                                   padding: '4px 8px',
                                   borderRadius: '4px',
                                   border: `1px solid ${theme.accent}`
                                 }}>(either/or)</span>
                                 <div>
                                   <Text strong style={{ fontSize: '16px', display: 'block', marginBottom: '4px' }}>
                                     Alternative Required
                                   </Text>
                                   <Text style={{ color: theme.textSecondary, lineHeight: '1.5' }}>
                                     Either this field OR another field is required. You can provide one or both, 
                                     but at least one is needed for the API call to succeed. Check the API documentation 
                                     to see which fields are alternatives to each other.
                                   </Text>
                                 </div>
                               </div>
                             </Col>

                             <Col span={24}>
                               <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                 <span style={{ 
                                   color: '#C678DD', 
                                   fontSize: '12px',
                                   fontWeight: 'bold',
                                   backgroundColor: '#C678DD20',
                                   padding: '4px 8px',
                                   borderRadius: '4px',
                                   border: '1px solid #C678DD'
                                 }}>(conditional)</span>
                                 <div>
                                   <Text strong style={{ fontSize: '16px', display: 'block', marginBottom: '4px' }}>
                                     Conditionally Required
                                   </Text>
                                   <Text style={{ color: theme.textSecondary, lineHeight: '1.5' }}>
                                     This field becomes required only when certain conditions are met. For example, 
                                     when another field has a specific value, or when using a particular API method. 
                                     Hover over the info icon to see the specific conditions.
                                   </Text>
                                 </div>
                               </div>
                             </Col>

                             <Col span={24}>
                               <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                 <span style={{ 
                                   color: theme.error, 
                                   fontSize: '12px',
                                   fontWeight: 'bold',
                                   backgroundColor: `${theme.error}20`,
                                   padding: '4px 8px',
                                   borderRadius: '4px',
                                   border: `1px solid ${theme.error}`
                                 }}>(exclusive)</span>
                                 <div>
                                   <Text strong style={{ fontSize: '16px', display: 'block', marginBottom: '4px' }}>
                                     Mutually Exclusive
                                   </Text>
                                   <Text style={{ color: theme.textSecondary, lineHeight: '1.5' }}>
                                     This field cannot be used together with certain other fields. You must choose 
                                     one or the other, not both. Using conflicting fields will result in an API error.
                                   </Text>
                                 </div>
                               </div>
                             </Col>

                             <Col span={24}>
                               <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                 <InfoCircleOutlined style={{ fontSize: '16px', color: theme.primary }} />
                                 <div>
                                   <Text strong style={{ fontSize: '16px', display: 'block', marginBottom: '4px' }}>
                                     Hover for More Information
                                   </Text>
                                   <Text style={{ color: theme.textSecondary, lineHeight: '1.5' }}>
                                     Hover over the info icon next to any field to see detailed descriptions, 
                                     validation rules, example values, and additional context about how to use that field.
                                   </Text>
                                 </div>
                               </div>
                             </Col>

                             <Col span={24}>
                               <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                 <div style={{ display: 'flex', gap: '4px' }}>
                                   <Tag color="green">GET</Tag>
                                   <Tag color="blue">POST</Tag>
                                   <Tag color="orange">PUT</Tag>
                                   <Tag color="red">DELETE</Tag>
                                 </div>
                                 <div>
                                   <Text strong style={{ fontSize: '16px', display: 'block', marginBottom: '4px' }}>
                                     HTTP Method Colors
                                   </Text>
                                   <Text style={{ color: theme.textSecondary, lineHeight: '1.5' }}>
                                     Color-coded tags indicate the HTTP method: GET (green), POST (blue), 
                                     PUT (orange), DELETE (red). This helps you quickly identify the type of operation.
                                   </Text>
                                 </div>
                               </div>
                             </Col>
                           </Row>

                           <div style={{ 
                             marginTop: '24px', 
                             padding: '16px', 
                             backgroundColor: theme.surfaceLight, 
                             borderRadius: '6px',
                             border: `1px solid ${theme.border}`
                           }}>
                             <Text style={{ fontWeight: '500', display: 'block', marginBottom: '8px' }}>
                               💡 Pro Tip
                             </Text>
                             <Text style={{ color: theme.textSecondary, fontSize: '13px', lineHeight: '1.5' }}>
                               Always check field indicators and hover over info icons before making API calls. 
                               This helps ensure your requests are properly formatted and reduces errors. 
                               When in doubt, refer to the detailed API documentation for each endpoint.
                             </Text>
                           </div>
                         </div>
                       </Modal>
                       
                       {selectedApi && (
                         <ApiForm
                           selectedApi={selectedApi}
                           initialRequestParams={requestParams}
                           onRunRequest={handleRunRequest}
                           onPreviewRequest={handlePreviewRequest}
                         />
                       )}
                     </div>

                     <div style={{ flex: 1 }}>
                       <Card
                         className="code-snippet-section"
                         title={<span style={{ color: theme.text }}>Request</span>}
                         bordered={false}
                         style={{ 
                           marginBottom: '20px',
                           backgroundColor: theme.surface,
                           border: `1px solid ${theme.border}`,
                         }}
                         extra={
                           <Button 
                             type="text" 
                             onClick={toggleRequestSize}
                             style={{ color: theme.textSecondary }}
                           >
                             {isRequestExpanded ? <CompressOutlined /> : <ExpandOutlined />}{' '}
                             {isRequestExpanded ? 'Collapse' : 'Expand'}
                           </Button>
                         }
                       >
                     <div style={{ 
  display: 'flex', 
  alignItems: 'center', 
  gap: '10px',
  marginBottom: '10px' 
}}>
  <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: theme.textSecondary,
    fontSize: '14px',
    fontWeight: '500'
  }}>
    <CodeOutlined style={{ fontSize: '16px' }} />
    <span>Language</span>
  </div>
 

<Select 
  value={selectedLanguage}
  style={{ 
    width: 200,
    boxShadow: currentTheme === 'dark' 
      ? '0 2px 4px rgba(0,0,0,0.2)' 
      : '0 2px 4px rgba(0,0,0,0.05)'
  }} 
  onChange={handleLanguageChange}
  showSearch
  filterOption={(input, option) => {
    if (!option || !input) return true;
    
    // Get the text content from the option's children
    const optionText = option.children || '';
    const searchText = input.toLowerCase();
    
    // Convert to string and search
    return String(optionText).toLowerCase().includes(searchText);
  }}
  placeholder="Select language..."
>
  <OptGroup 
    label={
      <div style={{ 
        color: theme.primary, 
        fontWeight: '600',
        fontSize: '12px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
      }}>
        Web & Backend
      </div>
    }
  >
    <Option value="Node">Node.js</Option>
    <Option value="TypeScript">TypeScript</Option>
    <Option value="Python">Python</Option>
    <Option value="Go">Go</Option>
    <Option value="PHP">PHP</Option>
    <Option value="Ruby">Ruby</Option>
    <Option value="Java">Java</Option>
    <Option value="Rust">Rust</Option>
  </OptGroup>
  
  <OptGroup 
    label={
      <div style={{ 
        color: '#9F7AEA', 
        fontWeight: '600',
        fontSize: '12px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        paddingTop: '8px'
      }}>
        🎮 Game Engines
      </div>
    }
  >
    <Option value="Unity C#">Unity C#</Option>
    <Option value="Unreal C++">Unreal C++</Option>
    <Option value="GDScript">Godot GDScript</Option>
    <Option value="Lua">Lua</Option>
  </OptGroup>
  
  <OptGroup 
    label={
      <div style={{ 
        color: '#48BB78', 
        fontWeight: '600',
        fontSize: '12px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        paddingTop: '8px'
      }}>
        📱 Mobile
      </div>
    }
  >
    <Option value="Swift">Swift (iOS)</Option>
    <Option value="Kotlin">Kotlin (Android)</Option>
    <Option value="Dart">Dart/Flutter</Option>
  </OptGroup>
  
  <OptGroup 
    label={
      <div style={{ 
        color: '#ED8936', 
        fontWeight: '600',
        fontSize: '12px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        paddingTop: '8px'
      }}>
        ⚙️ System & Native
      </div>
    }
  >
    <Option value="C++">C++</Option>
    <Option value="C#">C#</Option>
  </OptGroup>
  
  <OptGroup 
    label={
      <div style={{ 
        color: theme.textSecondary, 
        fontWeight: '600',
        fontSize: '12px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        paddingTop: '8px'
      }}>
        🛠️ Tools & Scripts
      </div>
    }
  >
    <Option value="cURL">cURL</Option>
    <Option value="Shell">Shell/Bash</Option>
    <Option value="PowerShell">PowerShell</Option>
  </OptGroup>
</Select>












  <Button
    type="link"
    icon={<CopyOutlined />}
    onClick={() => {
      if (codeSnippet) {
        navigator.clipboard.writeText(codeSnippet);
        message.success('Code snippet copied to clipboard');
      }
    }}
    style={{ 
      marginLeft: 'auto',
      color: theme.primary,
      display: 'flex',
      alignItems: 'center',
      gap: '4px'
    }}
  >
    Copy
  </Button>
</div>
                       
                         <RequestCodeDisplay
                           language={selectedLanguage}
                           codeSnippet={codeSnippet}
                           expanded={isRequestExpanded}
                         />
                       </Card>

                       <Card
                         title={<span style={{ color: theme.text }}>Response</span>}
                         className="response-section"
                         bordered={false}
                         style={{ 
                           backgroundColor: theme.surface,
                           border: `1px solid ${theme.border}`,
                         }}
                         extra={
                           <Button 
                             type="text" 
                             onClick={toggleEditorSize}
                             style={{ color: theme.textSecondary }}
                           >
                             {editorExpanded ? <CompressOutlined /> : <ExpandOutlined />}{' '}
                             {editorExpanded ? 'Collapse' : 'Expand'}
                           </Button>
                         }
                       >
                      <ApiResponse 
  response={response} 
  expanded={editorExpanded}
  selectedApi={selectedApi}
  requestParams={requestParams}
  isProductionMode={isProductionMode}
/>
                       </Card>
                     </div>
                   </div>
                 </>
               )}
             </Content>
             
             {/* Help/Documentation Drawer */}
             <Drawer
               placement="right"
               onClose={() => {
                 setHelpVisible(false);
                 setHelpDrawerFullscreen(false);
                 setActiveSection('sandbox');
               }}
               visible={helpVisible}
               width={helpDrawerFullscreen ? '100%' : (window.innerWidth < 768 ? '100%' : 900)}
               style={
                 helpDrawerFullscreen
                   ? {
                       top: 0,
                       margin: 0, 
                       padding: 0, 
                       zIndex: 9999
                     }
                   : {}
               }
               bodyStyle={{
                 backgroundColor: theme.surface,
                 padding: helpDrawerFullscreen ? '12px 24px' : '12px',
               }}
               destroyOnClose
               maskClosable
               headerStyle={{ backgroundColor: theme.surfaceLight, borderBottom: `1px solid ${theme.border}` }}
               title={
                 <Row justify="space-between" align="middle" style={{ width: '100%' }}>
                   <Col>
                     <Typography.Title level={4} style={{ margin: 0, color: theme.text }}>
                       Specter API Documentation
                     </Typography.Title>
                   </Col>
                   <Col>
                     <Button
                       type="text"
                       icon={helpDrawerFullscreen ? <CompressOutlined /> : <ExpandOutlined />}
                       onClick={() => setHelpDrawerFullscreen(prev => !prev)}
                       style={{ color: theme.textSecondary }}
                     />
                   </Col>
                 </Row>
               }
             >
               {/* Search Field */}
               <Input.Search
                 placeholder="Search documentation..."
                 onChange={(e) => setDocSearchQuery(e.target.value)}
                 value={docSearchQuery}
                 style={{ 
                   marginBottom: '16px',
                   backgroundColor: theme.surfaceLight,
                 }}
                 allowClear
               />
               <div
                 style={{
                   display: 'flex',
                   flexDirection: window.innerWidth < 768 ? 'column' : 'row',
                   gap: '16px'
                 }}
               >
                 {/* Left Navigation: List of documentation titles */}
                 <div
                   style={{
                     flex: '1 1 24%',
                     maxHeight: '80vh',
                     overflowY: 'auto',
                     
                     borderRight: window.innerWidth < 768 ? 'none' : `1px solid ${theme.border}`,
                     paddingRight: window.innerWidth < 768 ? '0' : '4px'
                   }}
                 >
                   <List
                     itemLayout="horizontal"
                     dataSource={filteredDocs}
                     renderItem={(doc) => (
                       <List.Item
                         style={{
                           padding: '8px 16px',
                           cursor: 'pointer',
                           borderBottom: `1px solid ${theme.border}`,
                           minHeight: '60px',
                           backgroundColor: selectedDoc && selectedDoc._id === doc._id ? theme.surfaceLight : "inherit"
                         }}
                         onClick={() => openDocumentation(doc)}
                       >
                         <List.Item.Meta
                           title={<span style={{ fontWeight: 'normal', color: theme.text }}>{doc.title}</span>}
                         />
                       </List.Item>
                     )}
                   />
                 </div>
                 {/* Right Pane: Documentation content */}
                 <div
                   style={{
                     flex: '1 1 60%',
                     maxHeight: '80vh',
                     overflowY: 'auto',
                     paddingRight: '20px'
                   }}
                 >
                   {helpContent.content ? (
                     <div
                       className={`documentation-content ${currentTheme === 'dark' ? 'dark-theme' : ''}`}
                       dangerouslySetInnerHTML={{ __html: helpContent.content }}
                     />
                   ) : (
                     <Typography.Text style={{ color: theme.textSecondary }}>
                       No documentation selected.
                     </Typography.Text>
                   )}
                 </div>
               </div>
             </Drawer>

             <HistoryModal
               visible={historyModalVisible}
               onClose={() => {
                 setHistoryModalVisible(false);
                 setActiveSection('sandbox');
               }}
               memberName={memberName}
               API_BASE_URL={API_BASE_URL}
               selectedEnv={selectedEnv}
               onLoadRequestFromHistory={handleLoadRequestFromHistory} 
               style={{ top: 30 }}
             />

             <ApiKeySelectorModal
               visible={showApiKeySelector}
               onSelect={(key) => {
                 setApiKey(key);
                 setShowApiKeySelector(false);
                 message.success('API Key selected');
               }}
               onCancel={() => setShowApiKeySelector(false)}
               orgId={selectedOrg ? selectedOrg.id : ''}
               authToken={authToken}
               orgApiKeys={selectedOrg ? orgApiKeys[selectedOrg.id] : {}}
               globalEnv={selectedEnv} 
               devIp={devIp}  
             />
             <IntegrationsModal
  visible={integrationsModalVisible}
  onClose={() => {
    setIntegrationsModalVisible(false);
    setActiveSection('sandbox');
  }}
  userId={isLoggedIn ? (localStorage.getItem('memberId') || authToken) : null}
  userEmail={memberName || localStorage.getItem('memberEmail') || ''}
  userName={memberName || 'User'}
  theme={theme}
  currentTheme={currentTheme}
/>
             {/* <AskAIModal
               visible={askAIModalVisible}
               onClose={() => setAskAIModalVisible(false)}
             />
             
             {isLoggedIn && (
               <Button
                 type="primary"
                 shape="circle"
                 icon={
                   <img 
                     src="/images/wand.png" 
                     alt="Wand icon" 
                     style={{ width: '24px', height: '24px', objectFit: 'contain' }} 
                   />
                 }
                 size="large"
                 style={{
                   position: 'fixed',
                   bottom: askaiButtonBottom,
                   right: 24,
                   zIndex: 1000,
                   background: `linear-gradient(135deg, ${theme.primary} 0%, ${theme.accent} 100%)`,
                   border: 'none',
                   boxShadow: currentTheme === 'dark' ? `0 4px 12px rgba(0, 0, 0, 0.5)` : `0 4px 12px rgba(0, 0, 0, 0.15)`,
                   transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                 }}
                 onMouseEnter={(e) => {
                   e.currentTarget.style.transform = 'scale(1.1)';
                   e.currentTarget.style.boxShadow = currentTheme === 'dark' ? `0 6px 16px rgba(0, 0, 0, 0.7)` : `0 6px 16px rgba(0, 0, 0, 0.25)`;
                 }}
                 onMouseLeave={(e) => {
                   e.currentTarget.style.transform = 'scale(1)';
                   e.currentTarget.style.boxShadow = currentTheme === 'dark' ? `0 4px 12px rgba(0, 0, 0, 0.5)` : `0 4px 12px rgba(0, 0, 0, 0.15)`;
                 }}
                 onClick={() => setAskAIModalVisible(true)}
               />
             )} */}

<Footer 
  ref={footerRef} 
  style={{ 
    background: `linear-gradient(180deg, ${theme.surface} 0%, ${theme.background} 100%)`,
    color: theme.text, 
    padding: '40px 50px 30px',
    borderTop: `1px solid ${theme.border}`,
    position: 'relative',
    overflow: 'hidden'
  }}
>
  {/* Subtle animated background */}
  <div style={{
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0.03,
    backgroundImage: `radial-gradient(circle at 20% 80%, ${theme.primary} 0%, transparent 50%),
                      radial-gradient(circle at 80% 20%, ${theme.accent} 0%, transparent 50%)`
  }} />

  <Row justify="space-between" align="top" gutter={[48, 48]} style={{ position: 'relative', zIndex: 1 }}>
    {/* Left Side: Logo and Description */}
    <Col xs={24} sm={12} md={8} lg={8}>
      <div style={{ marginBottom: '20px' }}>
        <img 
          src={currentTheme === 'dark' ? "/images/specter_logo_2.png" : "/images/Specter_LightMode.png"} 
          alt="Specter Logo" 
          style={{ 
            width: '160px', 
            opacity: 0.95,
            filter: `drop-shadow(0 4px 12px ${theme.primary}20)`
          }} 
        />
      </div>
      <Paragraph style={{ 
        color: theme.textSecondary,
        fontSize: '14px',
        lineHeight: '1.6',
        marginBottom: '20px',
        maxWidth: '300px'
      }}>
        Building the future of gaming infrastructure with powerful APIs and tools for developers.
      </Paragraph>
      <Text style={{ 
        color: theme.textSecondary,
        fontSize: '13px',
        display: 'block'
      }}>
        Specter ©2024 | Created by Dirtcube Interactive
      </Text>
    </Col>

    {/* Middle: Navigation Links */}
    <Col xs={24} sm={12} md={8} lg={8}>
      <Title level={5} style={{ 
        color: theme.text,
        fontSize: '16px',
        fontWeight: '600',
        marginBottom: '20px'
      }}>
        Quick Links
      </Title>
      <Row gutter={[32, 0]}>
        {/* Left column - Main links */}
        <Col xs={24} sm={16} md={16} lg={16}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <Link 
              href="https://manual.specterapp.xyz/specter-user-manual" 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ 
                color: theme.textSecondary,
                fontSize: '14px',
                transition: 'color 0.2s ease',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = theme.primary}
              onMouseLeave={(e) => e.currentTarget.style.color = theme.textSecondary}
            >
              <BookOutlined /> Specter Manual
            </Link>
            <Link 
              href="https://doc.specterapp.xyz" 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ 
                color: theme.textSecondary,
                fontSize: '14px',
                transition: 'color 0.2s ease',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = theme.primary}
              onMouseLeave={(e) => e.currentTarget.style.color = theme.textSecondary}
            >
              <ApiOutlined /> API Documentation
            </Link>
            <Link 
              href="https://medium.com/specter-chronicles" 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ 
                color: theme.textSecondary,
                fontSize: '14px',
                transition: 'color 0.2s ease',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = theme.primary}
              onMouseLeave={(e) => e.currentTarget.style.color = theme.textSecondary}
            >
              <ReadOutlined /> Blogs
            </Link>
            <Link 
              href="https://discord.com/invite/BZSF94yg2K" 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ 
                color: theme.textSecondary,
                fontSize: '14px',
                transition: 'color 0.2s ease',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#5865F2'}
              onMouseLeave={(e) => e.currentTarget.style.color = theme.textSecondary}
            >
              <MessageOutlined /> Join Discord Community
            </Link>
            <Link 
              href="https://specter.canny.io/feedback" 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ 
                color: theme.textSecondary,
                fontSize: '14px',
                transition: 'color 0.2s ease',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = theme.primary}
              onMouseLeave={(e) => e.currentTarget.style.color = theme.textSecondary}
            >
              <CommentOutlined /> Submit Feedback
            </Link>
          </div>
        </Col>
        
        {/* Right column - Secondary links */}
        <Col xs={24} sm={8} md={8} lg={8}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <Link 
              href="https://www.specterapp.xyz/about" 
              target="_blank" 
              style={{ 
                color: theme.textSecondary,
                fontSize: '14px',
                transition: 'color 0.2s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = theme.primary}
              onMouseLeave={(e) => e.currentTarget.style.color = theme.textSecondary}
            >
              About Us
            </Link>
            <Link 
              href="mailto:hello@specterapp.xyz" 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ 
                color: theme.textSecondary,
                fontSize: '14px',
                transition: 'color 0.2s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = theme.primary}
              onMouseLeave={(e) => e.currentTarget.style.color = theme.textSecondary}
            >
              Contact
            </Link>
            <Link 
              href="https://www.specterapp.xyz/privacyPolicy" 
              target="_blank" 
              style={{ 
                color: theme.textSecondary,
                fontSize: '14px',
                transition: 'color 0.2s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = theme.primary}
              onMouseLeave={(e) => e.currentTarget.style.color = theme.textSecondary}
            >
              Privacy Policy
            </Link>
            <Link 
              href="https://www.specterapp.xyz/termsOfService" 
              target="_blank" 
              style={{ 
                color: theme.textSecondary,
                fontSize: '14px',
                transition: 'color 0.2s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = theme.primary}
              onMouseLeave={(e) => e.currentTarget.style.color = theme.textSecondary}
            >
              Terms of Service
            </Link>
          </div>
        </Col>
      </Row>
    </Col>

    {/* Right Side: Social Media Icons */}
    <Col xs={24} sm={24} md={8} lg={8} style={{ textAlign: window.innerWidth >= 768 ? 'right' : 'left' }}>
      <Title level={5} style={{ 
        color: theme.text,
        fontSize: '16px',
        fontWeight: '600',
        marginBottom: '20px'
      }}>
        Connect With Us
      </Title>
      <Space size={[16, 16]} wrap style={{ marginBottom: '24px' }}>
        <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: theme.surfaceLight,
            border: `1px solid ${theme.border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#1877F2';
            e.currentTarget.style.borderColor = '#1877F2';
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.querySelector('svg').style.color = '#ffffff';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = theme.surfaceLight;
            e.currentTarget.style.borderColor = theme.border;
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.querySelector('svg').style.color = theme.textSecondary;
          }}>
            <FacebookOutlined style={{ fontSize: '20px', color: theme.textSecondary, transition: 'color 0.3s' }} />
          </div>
        </a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: theme.surfaceLight,
            border: `1px solid ${theme.border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#000000';
            e.currentTarget.style.borderColor = '#000000';
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.querySelector('img').style.filter = 'brightness(0) invert(1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = theme.surfaceLight;
            e.currentTarget.style.borderColor = theme.border;
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.querySelector('img').style.filter = currentTheme === 'dark' ? 'invert(1)' : 'none';
          }}>
            <img 
              src={`${process.env.PUBLIC_URL}/images/x.svg`} 
              alt="Twitter" 
              style={{ 
                width: '18px', 
                height: '18px', 
                filter: currentTheme === 'dark' ? 'invert(1)' : 'none',
                transition: 'filter 0.3s'
              }} 
            />
          </div>
        </a>
        <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: theme.surfaceLight,
            border: `1px solid ${theme.border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'linear-gradient(45deg, #F58529, #DD2A7B, #8134AF, #515BD4)';
            e.currentTarget.style.borderColor = 'transparent';
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.querySelector('svg').style.color = '#ffffff';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = theme.surfaceLight;
            e.currentTarget.style.borderColor = theme.border;
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.querySelector('svg').style.color = theme.textSecondary;
          }}>
            <InstagramOutlined style={{ fontSize: '20px', color: theme.textSecondary, transition: 'color 0.3s' }} />
          </div>
        </a>
        <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: theme.surfaceLight,
            border: `1px solid ${theme.border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#0A66C2';
            e.currentTarget.style.borderColor = '#0A66C2';
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.querySelector('svg').style.color = '#ffffff';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = theme.surfaceLight;
            e.currentTarget.style.borderColor = theme.border;
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.querySelector('svg').style.color = theme.textSecondary;
          }}>
            <LinkedinOutlined style={{ fontSize: '20px', color: theme.textSecondary, transition: 'color 0.3s' }} />
          </div>
        </a>
      </Space>
      
      <div style={{
        backgroundColor: theme.surfaceLight,
        border: `1px solid ${theme.border}`,
        borderRadius: '8px',
        padding: '16px',
        maxWidth: '280px',
        marginLeft: window.innerWidth >= 768 ? 'auto' : '0'
      }}>
        <Text style={{
          fontSize: '13px',
          color: theme.text,
          fontWeight: '500',
          display: 'block',
          marginBottom: '8px'
        }}>
          Ready to build something amazing?
        </Text>
        <Button
          type="primary"
          size="middle"
          icon={<RocketOutlined />}
          style={{
            background: `linear-gradient(135deg, ${theme.primary} 0%, ${theme.primaryDark} 100%)`,
            border: 'none',
            boxShadow: `0 2px 8px ${theme.primary}40`,
            width: '100%'
          }}
          onClick={() => window.open('https://console.specterapp.xyz', '_blank')}
        >
          Get Started
        </Button>
      </div>
    </Col>
  </Row>
</Footer>
           </Layout>
         </Layout>
       </ConfigProvider>
       
       </>
     )}

     </>
   </ThemeContext.Provider>
 );
}

export default App;